import { report360 } from '@/locales/es-ES/report360';
export const assets = {
list: {
zonesAction: "Zonas",
zonesTitle_one: "Zonas de {{count}} activo",
zonesTitle_many: "Zonas de {{count}} activos",
zonesTitle_other: "Zonas de {{count}} activos",
zonesAdd: "A\u00f1adir zonas",
zonesRemove: "Quitar",
zonesSaved_one: "Zonas guardadas en {{count}} activo",
zonesSaved_many: "Zonas guardadas en {{count}} activos",
zonesSaved_other: "Zonas guardadas en {{count}} activos",
zonesFailedTitle: "No se pudieron guardar las zonas",
zonesFailedBody: "Puede que algunos activos no hayan cambiado. Comprueba tu conexi\u00f3n e int\u00e9ntalo de nuevo.",
  showMeHow: "Muéstrame cómo",
title: "Activos",
viewList: "Vista de lista",
viewCards: "Vista de tarjetas",
viewGraph: "Vista de red — mapa de calor por estado",
viewMap: "Vista de mapa",
viewLabel: "Vista",
subtitleOwned_one: "{{count}} activo",
subtitleOwned_other: "{{count}} activos",
subtitleOwnedOfLimit_one: "{{owned}} de {{count}} activo",
subtitleOwnedOfLimit_many: "{{owned}} de {{count}} activos",
subtitleOwnedOfLimit_other: "{{owned}} de {{count}} activos",
subtitleSharedEmpty: "Los informes compartidos contigo aparecen aquí",
subtitleShared_one: "{{count}} activo compartido con usted",
subtitleShared_other: "{{count}} activos compartidos con usted",
shareWithContactSubtitle: "Compartir un activo con {{name}}",
shareWithContactSubtitleNoName: "Compartir un activo con este contacto",
searchPlaceholder: "Buscar",
searchA11y: "Buscar activos",
refine: "Refinar",
refineA11y: "Refinar lista de activos",
tools: "Herramientas",
addAsset: "Añadir activo",
trySample: "Probar ejemplo",
trySampleError: "No se pudo preparar el ejemplo. Cree un activo manualmente.",
addAssetA11y: "Añadir nuevo activo",
refineSheetTitle: "Refinar activos",
scope: "Ámbito",
groupBy: "Agrupar por",
filters: "Filtros",
pickerType: "Tipo de activo",
pickerSort: "Ordenar por",
pickerHealth: "Puntuación de salud",
pickerRelationship: "Tipo de relación",
toolsMenuTitle: "Herramientas",
selectAssets: "Seleccionar activos",
scanQr: "Escanear QR",
exportAllCsv: "Exportar todo (CSV)",
exportAllA11y: "Descargar todos los activos visibles como CSV",
emptyNoAssetsTitle: "Aún no hay activos",
emptyNoAssetsSub: "Añade tu primer activo para empezar inspecciones y trabajos en él.",
emptyContractorSub: "Los activos que tus clientes comparten contigo aparecen aquí; las órdenes de trabajo que te asignan están en Trabajo. También puedes registrar los tuyos.",
emptySharedNoneTitle: "Aún no hay activos compartidos",
emptySharedNoneSub: "Los activos de inspecciones compartidas contigo aparecerán aquí. Abre un informe compartido desde Actividad o tu enlace de correo.",
emptyScopeTitle: "No hay activos en {{scope}}",
emptyScopeSub: "Cambia el filtro de ámbito o añade activos a este equipo.",
emptyFilterTitle: "No hay activos coincidentes",
emptyFilterSub: "Prueba otros términos o borra los filtros.",
clearFilters: "Borrar filtros",
webViewerEmptyTitle: "Ninguna fila seleccionada",
webViewerEmptySub: "Selecciona un activo en la lista para abrir el visor debajo.",
workspaceInsightSummary: "{{total}} en la vista · {{poor}} en estado deficiente · {{watch}} en vigilancia · {{good}} en buen estado · {{unscored}} sin puntuar",
operationalInsight: {
insightPanelTitle: "Información del registro",
insightSourceExisting: "Bandas de estado existentes de los activos",
summaryLine: "{{total}} activos · {{poor}} estado deficiente · {{watch}} en vigilancia · {{good}} bueno · {{unscored}} sin puntuación",
poorExplanation_one: "{{count}} activo tiene una puntuación de estado de 40 o menos.",
poorExplanation_many: "{{count}} activos tienen una puntuación de estado de 40 o menos.",
poorExplanation_other: "{{count}} activos tienen una puntuación de estado de 40 o menos.",
poorRecommended: "Prioriza las inspecciones, trabajos y documentos que están afectando esas puntuaciones.",
poorCta: "Filtrar por estado deficiente",
watchExplanation_one: "{{count}} activo está en la banda de vigilancia (41–70).",
watchExplanation_many: "{{count}} activos están en la banda de vigilancia (41–70).",
watchExplanation_other: "{{count}} activos están en la banda de vigilancia (41–70).",
watchRecommended: "Planifica inspecciones o acciones correctivas antes de que pasen a estado deficiente.",
watchCta: "Filtrar banda de vigilancia",
unscoredExplanation_one: "{{count}} activo todavía no tiene una puntuación de estado.",
unscoredExplanation_many: "{{count}} activos todavía no tienen una puntuación de estado.",
unscoredExplanation_other: "{{count}} activos todavía no tienen una puntuación de estado.",
unscoredRecommended: "Completa los detalles del perfil y realiza inspecciones para que se pueda calcular la puntuación.",
unscoredCta: "Abrir Refinar",
balancedExplanation: "Ningún activo de esta vista está en estado deficiente o en la banda de vigilancia.",
balancedRecommended: "Mantén las inspecciones y los trabajos al día para conservar puntuaciones estables.",
refineCta: "Refinar lista",
exportCsvLabel: "Exportar activos visibles (CSV)",
},
cancel: "Cancelar",
selected_one: "{{count}} seleccionado",
selected_other: "{{count}} seleccionados",
clearVisible: "Deseleccionar visibles",
allVisible: "Todos los visibles",
exportCsv: "Exportar CSV",
bulkExportA11y: "Exportar activos seleccionados como CSV",
bulkSelectAllA11y: "Seleccionar todos los activos visibles",
bulkDeselectAllA11y: "Deseleccionar todos los visibles",
printLabels: "Imprimir etiquetas",
assignTeam: "Asignar equipo",
assignToTeam: "Asignar al equipo",
personal: "Personal",
unknownTeam: "Equipo desconocido",
qrPrintTitle: "Imprimir etiquetas para activos seleccionados",
exportNoSelectionTitle: "Ningún activo seleccionado",
exportNoSelectionBody: "Selecciona al menos un activo visible para exportar.",
exportCopiedTitle: "Exportación copiada",
exportCopiedBody_one: "Se copió {{count}} fila de activo como CSV.",
exportCopiedBody_other: "Se copiaron {{count}} filas de activos como CSV.",
exportErrorTitle: "Error",
exportErrorBody: "No se pudieron actualizar los activos.",
typeChip: "Tipo",
sortChip: "Orden",
healthChip: "Salud",
relationshipChip: "Relación",
typeAll: "Todos los tipos",
typeCar: "Vehículo",
typeProperty: "Lugar",
typeEquipment: "Equipo",
typeOther: "Otro",
kindAll: "Todos",
kindPlaces: "Lugares",
kindEquipment: "Equipos",
kindVehicles: "Vehículos",
sortNewest: "Más recientes primero",
sortOldest: "Más antiguos primero",
sortNameAsc: "Nombre A–Z",
sortNameDesc: "Nombre Z–A",
sortLastInspected: "Última inspección",
sortMostInspections: "Más inspecciones",
healthAny: "Cualquier puntuación",
healthLt80: "Puntuación inferior a 80",
healthLt60: "Puntuación inferior a 60",
relationshipAll: "Cualquier relación",
groupType: "Tipo",
groupTeam: "Equipo",
viewActivity: "Ver actividad",
signalNoInspection: "Sin inspección",
signalNoData: "Sin datos",
loadingMore: "Cargando más…",
endOfList_one: "{{count}} activo: esto es todo",
endOfList_other: "{{count}} activos: esto es todo",
endOfListInView_one: "{{count}} activo en esta vista",
endOfListInView_other: "{{count}} activos en esta vista",
signalScore: "Puntuación {{score}}",
signalNoHealthScore: "Sin puntuación de salud",
signalRisk: "Riesgo {{level}}",
signalNoRisk: "Sin puntuación de riesgo",
signalNotScored: "Sin puntuar",
healthGood: "Buena",
healthWatch: "Vigilar",
healthPoor: "Deficiente",
riskLow: "Bajo",
riskMedium: "Medio",
riskHigh: "Alto",
riskExtreme: "Extremo",
csvHeaderAsset: "Activo",
csvHeaderType: "Tipo",
csvHeaderHealthStatus: "Estado de salud",
csvHeaderHealthScore: "Puntuación de salud",
csvHeaderRisk: "Riesgo",
csvHeaderRiskScore: "Puntuación de riesgo",
csvHeaderOpenJobs: "Trabajos abiertos",
csvHeaderOverdueJobs: "Trabajos atrasados",
csvHeaderLastInspection: "Última inspección",
csvHeaderCreated: "Creado",
csvExportName: "Nombre",
csvExportType: "Tipo",
csvExportTeam: "Equipo",
csvExportCreated: "Creado",
csvExportUpdated: "Actualizado",
insightStripTitle: "Resumen de salud",
healthStatusHeadline: "{{critical}} críticos · {{warning}} en seguimiento",
healthStatusSecondary: "{{good}} en buen estado · {{unscored}} sin puntuación",
queueAttention: "Requieren atención",
queueAll: "Todos los activos",
queueShared: "Compartidos",
queueTablistA11y: "Vista de la lista de activos",
inspectPriority: "Inspeccionar el más prioritario",
inspectPriorityA11y: "Abrir el activo prioritario que requiere atención",
advancedFiltersTitle: "Filtros avanzados y ordenación",
advancedFiltersSummary_one: "{{count}} refinamiento activo",
advancedFiltersSummary_other: "{{count}} refinamientos activos",
advancedFiltersSummaryEmpty: "Tipo, salud, orden, agrupación, ámbito",
advancedFiltersExpand: "Mostrar filtros",
advancedFiltersCollapse: "Ocultar filtros",
emptyAttentionClearTitle: "Nada requiere atención",
emptyAttentionClearSub: "Todos los activos en este ámbito están en buen estado o sin puntuación.",
emptyAttentionShowAll: "Mostrar todos los activos",
emptySharedTitle: "Nada compartido contigo",
emptySharedSub: "Aquí aparecen los activos que otro espacio de trabajo comparte contigo.",
subtitleOwned_many: "{{count}} activos",
subtitleShared_many: "{{count}} activos compartidos con usted",
selected_many: "{{count}} seleccionados",
exportCopiedBody_many: "Se copiaron {{count}} filas de activos como CSV.",
endOfList_many: "{{count}} activos: esto es todo",
endOfListInView_many: "{{count}} activos en esta vista",
advancedFiltersSummary_many: "{{count}} refinamientos activos",
moreActions: "Más acciones",
queueRetired: "Retirados definitivamente",
},
contacts: {
emptyTitle: "Aún no hay contactos vinculados",
emptyDescription: "Vincula propietarios, inquilinos, contratistas o gestores — y comparte el acceso al mismo tiempo.",
emptyWithRecipients_one: "{{count}} persona ha recibido un informe de este activo pero aún no está vinculada. Vincúlela para mantener la relación en el activo.",
emptyWithRecipients_other: "{{count}} personas han recibido informes de este activo pero aún no están vinculadas. Vincúlelas para mantener la relación en el activo.",
linkContact: "Vincular contacto",
reportRecipients: "Destinatarios del informe",
recipientCount_one: "{{count}} destinatario",
recipientCount_other: "{{count}} destinatarios",
emptyWithRecipients_many: "{{count}} personas han recibido informes de este activo pero aún no están vinculadas. Vincúlelas para mantener la relación en el activo.",
recipientCount_many: "{{count}} destinatarios",
},
shared: {
  contactRelationship: {
    other: "Otro",
    manager: "Responsable",
    occupant: "Ocupante",
    site_contact: "Contacto en el sitio",
    reviewer: "Revisa el trabajo",
    approver: "Aprueba el trabajo",
    observer: "Informado",
    supplier: "Proveedor",
    contractor: "Contratista",
    client: "Cliente",
    landlord: "Arrendador",
    tenant: "Inquilino",
    owner: "Propietario",
    recipient: "Recibe informes",
    requester: "Informa de problemas",
    assignee: "Hace el trabajo",
  },
  disposalMethod: {
    other: "Otro",
    donated: "Donado",
    transferred: "Transferido",
    returned: "Devuelto al arrendador",
    recycled: "Reciclado",
    scrapped: "Desguazado",
    sold: "Vendido",
  },
  retirementReason: {
    other: "Otro",
    lost: "Perdido o robado",
    replaced: "Sustituido",
    decommissioned: "Retirado del servicio",
    disposed: "Desechado",
    sold: "Vendido",
  },
  decommissionReason: {
    other: "Otro",
    relocated: "Trasladado",
    seasonal: "Parada de temporada",
    replaced: "Sustituido",
    fault: "Avería",
    end_of_life: "Fin de vida útil",
  },
  standing: {
    active: "Activo",
    retired: "Retirado definitivamente",
    archived: "Archivado",
    decommissioned: "Fuera de servicio",
    planned: "Aún no está en servicio",
    in_service: "En servicio",
  },
  complianceTag: {
    warranty_active: "En garantía",
    insurance_required: "Seguro obligatorio",
    ppe: "Equipo de protección",
    pressure_system: "Sistema a presión",
    lifting_equipment: "Equipos de elevación",
    vehicle_roadworthy: "Vehículo apto para circular",
    energy_performance: "Eficiencia energética (certificado)",
    water_hygiene: "Higiene del agua",
    gas_safety: "Seguridad del gas",
    electrical_safety: "Seguridad eléctrica",
    fire_safety: "Seguridad contra incendios",
  },
  operatingContext: {
    operational: "Operación diaria",
    storage: "Almacenamiento",
    shared_use: "Uso compartido",
    staff_only: "Solo personal",
    customer_facing: "Usado por clientes",
  },
  lifecycle: {
    decommissioned: "Fuera de servicio",
    under_renovation: "En reforma",
    partially_operational: "Parcialmente en servicio",
    operational: "En servicio",
    handover: "En entrega",
    partially_developed: "Parcialmente construido",
    in_development: "En construcción",
    planned: "Planificado",
  },
  otherDomain: {
    other: "Otro",
    miscellaneous: "Varios",
    storage: "Almacenamiento",
    fixture: "Instalación fija",
    inventory: "Inventario",
    signage: "Señalización",
    it: "Equipos informáticos",
    furniture: "Mobiliario",
  },
  installation: {
    vehicle_mounted: "Montado en vehículo",
    portable: "Portátil",
    fixed: "Fijo",
  },
  powerSource: {
    pneumatic: "Neumática",
    hydraulic: "Hidráulica",
    manual: "Accionamiento manual",
    gas: "A gas",
    petrol: "Gasolina",
    diesel: "Diésel",
    battery: "Batería",
    electric: "Eléctrica",
  },
  equipmentClass: {
    other: "Otro",
    kitchen_equipment: "Equipo de cocina",
    appliance: "Electrodoméstico",
    electrical_distribution: "Distribución eléctrica",
    fire_system: "Sistema contra incendios",
    safety_equipment: "Equipo de seguridad",
    cleaning_machine: "Máquina de limpieza",
    machine: "Máquina",
    power_tool: "Herramienta eléctrica",
    lift: "Ascensor",
    compressor: "Compresor",
    forklift: "Carretilla elevadora",
    pump: "Bomba",
    generator: "Generador",
    boiler: "Caldera",
    hvac: "Climatización",
  },
  vehicleUsage: {
    plant_support: "Apoyo a maquinaria",
    site_use: "Uso en el sitio",
    passenger_transport: "Transporte de pasajeros",
    delivery: "Reparto",
    fleet: "Flota",
    personal: "Personal",
  },
  vehicleFuel: {
    other: "Otro",
    lpg: "GLP",
    electric: "Eléctrico",
    hybrid: "Híbrido",
    diesel: "Diésel",
    petrol: "Gasolina",
  },
  vehicleClass: {
    other: "Otro",
    plant_vehicle: "Maquinaria de obra",
    bus: "Autobús",
    motorcycle: "Motocicleta",
    trailer: "Remolque",
    truck: "Camión",
    van: "Furgoneta",
    car: "Coche",
  },
  occupancy: {
    new_build: "Obra nueva",
    under_renovation: "En reforma",
    partially_occupied: "Parcialmente ocupado",
    vacant: "Vacío",
    occupied: "Ocupado",
  },
  propertySubtype: {
    other: "Otro",
    depot: "Depósito",
    plant: "Planta",
    yard: "Patio",
    workshop: "Taller",
    factory: "Fábrica",
    warehouse: "Almacén",
    mixed_use: "Uso mixto",
    education: "Colegio o universidad",
    healthcare: "Sanidad",
    hospitality: "Hotel o restaurante",
    retail: "Comercio",
    office: "Oficina",
    holiday_rental: "Alquiler vacacional",
    student_accommodation: "Residencia de estudiantes",
    studio: "Estudio",
    townhouse: "Casa adosada",
    flat: "Piso",
    apartment: "Apartamento",
    house: "Casa",
  },
assetType: {
car: "Vehículo",
property: "Lugar",
equipment: "Equipo",
other: "Otro",
},
externalIdType: {
vin: "Número de bastidor",
serial: "Número de serie",
registration: "Matrícula",
barcode: "Código de barras",
custom: "ID personalizado",
},
documentType: {
certificate: "Certificado",
warranty: "Garantía",
compliance: "Cumplimiento",
general: "General",
},
criticality: {
low: "Baja",
medium: "Media",
high: "Alta",
critical: "Crítica",
},
mobility: {
fixed: "Fijo",
movable: "Desplazable",
mobile: "Móvil",
},
propertyFamily: {
residential: "Residencial",
commercial: "Comercial",
industrial: "Industrial",
},
furnishedStatus: {
unfurnished: "Sin amueblar",
part_furnished: "Parcialmente amueblado",
fully_furnished: "Totalmente amueblado",
},
propertySystem: {
hvac: "Climatización",
electrical: "Electricidad",
plumbing: "Fontanería",
fire_alarm: "Alarma contra incendios",
sprinklers: "Rociadores",
security_alarm: "Alarma de seguridad",
access_control: "Control de acceso",
cctv: "Videovigilancia",
lift: "Ascensor",
solar: "Energía solar",
},
vehicleTransmission: {
manual: "Cambio manual",
automatic: "Automática",
semi_automatic: "Semiautomática",
},
vehicleConditionFlag: {
road_legal: "Apto para circular",
insured: "Asegurado",
under_warranty: "En garantía",
service_contract: "Contrato de mantenimiento",
high_mileage: "Kilometraje alto",
off_road_use: "Uso todoterreno",
},
equipmentConditionFlag: {
service_contract: "Contrato de mantenimiento",
under_warranty: "En garantía",
calibration_required: "Requiere calibración",
inspection_required: "Requiere inspección",
safety_critical: "Crítico para la seguridad",
},
equipmentCapacityUnit: {
litres: "Litros",
tonnes: "Toneladas",
other: "Otra",
},
equipmentSafetyClass: {
general: "General",
safety_critical: "Crítico para la seguridad",
lifting: "Elevación",
pressure: "Presión",
electrical: "Eléctrico",
fire_safety: "Protección contra incendios",
},
equipmentOperatingEnvironment: {
indoor: "Interior",
outdoor: "Exterior",
mixed: "Mixto",
wet_area: "Zona húmeda",
dusty: "Con polvo",
high_temperature: "Alta temperatura",
cold_environment: "Entorno frío",
},
otherRiskTag: {
fragile: "Frágil",
high_value: "Alto valor",
regulated: "Regulado",
public_facing: "De cara al público",
portable: "Portátil",
safety_critical: "Crítico para la seguridad",
},
otherMiscKind: {
general: "General / sin categoría",
documentation: "Documentación y registros",
consumables: "Consumibles",
spare_parts: "Repuestos",
tooling: "Herramientas y equipos",
display_marketing: "Exposición y marketing",
safety_supplies: "Material de seguridad",
mixed_stock: "Existencias mixtas",
},
compliancePosture: {
clear: "Correcto",
watch: "Vigilar",
action: "Requiere acción",
},
externalIdPlaceholder: {
vin: "p. ej. 1HGBH41JXMN109186",
serial: "p. ej. SN-2024-00123",
registration: "p. ej. ABC 1234",
barcode: "p. ej. escanea o introduce el código de barras o el valor QR",
custom: "Introduce una referencia personalizada...",
},
},
documents: {
add: {
  editHint: "Cambie las fechas, el aviso, el título o las notas y toque Guardar documento. El archivo no cambia.",
  editTitle: "Editar detalles del documento",
pickTitle: "Añadir documento",
pickBody: "Elige cómo quieres adjuntar el documento.",
labels: {
  validMonths: "Válido {{months}} meses",
  subtype: "Clase de documento",
referenceNumber: "Certificado / número de referencia",
documentType: "Tipo de documento",
title: "Título",
file: "Archivo",
issueDate: "Fecha de emisión",
expiryDate: "Fecha de caducidad",
reminderDays: "Avisarme estos días antes de que caduque",
notes: "Notas",
validator: "¿Quién lo revisa y aprueba?",
validatorHint: "Recibe una notificación y una tarea hasta que lo apruebe o lo rechace.",
validatorNoTeam: "Este activo aún no tiene un equipo gestor, así que la validación queda contigo.",
validatorMe: "Yo",
validatorApprover: "Aprobador del activo",
},
placeholders: {
referenceNumber: "p. ej. ABC123456 (opcional)",
title: "p. ej. Certificado de seguridad de gas",
titleRenewed: "Certificado renovado",
file: "Elige un archivo para subir",
issueDate: "AAAA-MM-DD",
expiryDate: "AAAA-MM-DD",
notes: "Notas privadas sobre este documento",
},
a11y: {
saveDocument: "Guardar documento",
},
actions: {
saving: "Guardando...",
submit: "Guardar documento",
},
ai: {
title: "Detalles del documento con IA",
suggestAction: "Sugerir detalles con IA",
prompt: "Extrae el título, el tipo y las fechas del archivo subido cuando estés en línea.",
reviewHint: "Revisa los campos sugeridos antes de guardar. Los certificados siguen requiriendo validación.",
applyAll: "Aplicar todas las sugerencias",
providerName: "Proveedor / emisor",
assetIdentifier: "Identificador del activo en el documento",
},
alerts: {
photoPermission: "Permite el acceso a la galería de fotos para elegir una imagen del documento.",
cameraPermission: "Permite el acceso a la cámara para capturar un documento.",
documentPicker: "No se ha podido abrir el selector de archivos.",
assetNotFound: "Activo no encontrado.",
titleRequired: "Introduce un título para el documento.",
fileRequired: "Elige un archivo para subir.",
signInRequired: "Vuelve a iniciar sesión antes de guardar este documento.",
saveFailed: "No se ha podido guardar este documento.",
},
      energy: {
        scheme: "Tipo de certificado",
        schemeEPC: "EPC (certificado energético)",
        schemeDEC: "DEC (certificado de exposición)",
        rating: "Calificación",
        score: "Puntuación",
        scorePlaceholder: "p. ej., 68",
        isLet: "El edificio está alquilado",
        isLetHint: "Un edificio alquilado en Inglaterra y Gales necesita E o mejor.",
        belowMinimum: "Por debajo de E: este edificio no puede alquilarse con esta calificación sin una exención.",
        ratingRequired: "Elija la calificación del certificado.",
      },
},
},
relationships: {
  alerts: {
    duplicateCheckFailedTitle: "No se pudieron buscar duplicados",
    markDistinct: "No, son distintos",
    markDuplicate: "Sí, marcar como posible duplicado",
    duplicateFoundBody: "{{name}} se parece a este activo. ¿Es el mismo?",
    duplicateFoundTitle: "Podría ser el mismo activo",
    noDuplicatesBody: "Ningún otro activo coincide con este.",
    noDuplicatesTitle: "No se encontraron duplicados",
    mergeFailedTitle: "No se pudo fusionar",
    merge: "Fusionar",
    mergeBody: "Este activo se marca como fusionado. Su historial se conserva.",
    mergeTitle: "¿Fusionar con el otro registro?",
    canonicalFailedTitle: "No se pudo marcar el registro principal",
    removeFailedTitle: "No se pudo quitar el vínculo",
    remove: "Quitar",
    cancel: "Cancelar",
    removeBody: "Los dos activos se mantienen. Solo se quita el vínculo entre ellos.",
    removeTitle: "¿Quitar este vínculo?",
    tryAgain: "Comprueba tu conexión e inténtalo de nuevo.",
    updateFailedTitle: "No se pudo guardar el vínculo",
    addFailedTitle: "No se pudo añadir el vínculo",
    selectAssetBody: "Busca el activo que quieres vincular y tócalo.",
    selectAssetTitle: "Elige un activo",
  },
views: {
list: "Lista",
tree: "Árbol",
map: "Mapa",
},
refine: "Refinar",
refineA11y: "Refinar el mapa",
refineTitle: "Refinar el mapa",
refineShow: "Mostrar",
refineRisk: "Riesgo",
refineCriticality: "Criticidad",
refineDepth: "Profundidad",
refineColour: "Colorear por",
refineLayout: "Disposición",
filter: {
all: "Todas",
hierarchy: "Jerarquía",
dependency: "Dependencia",
association: "Asociación",
duplicate: "Duplicado",
inbound: "Entrantes",
outbound: "Salientes",
},
riskOnly: "Solo relevantes para el riesgo",
highlightCritical: "Resaltar críticas",
hops_one: "{{count}} nivel",
hops_other: "{{count}} niveles",
colour: {
combined: "Todo",
health: "Estado",
type: "Tipo",
risk: "Categoría del enlace",
},
layout: {
auto: "Automática",
hierarchy: "Jerarquía",
force: "Red",
radial: "Radial",
grid: "Cuadrícula",
},
groups: {
parents: "Superiores / contenedores",
children: "Inferiores / contenidos",
dependsOn: "Depende de",
supports: "Soporta / afecta a",
related: "Relacionados",
canonical: "Registro principal",
duplicates: "Posibles duplicados",
},
emptyTitle: "Aún no hay relaciones definidas",
emptyBody: "Vincule un activo superior, un componente o un activo par para que se conozcan las dependencias y el impacto.",
linkAsset: "Vincular activo",
linkAssetA11y: "Vincular un activo",
checkDuplicates: "Buscar duplicados",
checkDuplicatesA11y: "Buscar activos duplicados",
setCanonical: "Convertir en registro principal",
merge: "Fusionar",
compare: "Comparar",
comparison: "Comparación",
loadingGraph: "Cargando el grafo...",
mapAssets_one: "{{count}} activo",
mapAssets_other: "{{count}} activos",
mapLinks_one: "{{count}} enlace",
mapLinks_other: "{{count}} enlaces",
mapImpacts_one: "afecta a {{count}} relacionado desde aquí",
mapImpacts_many: "afecta a {{count}} relacionados desde aquí",
mapImpacts_other: "afecta a {{count}} relacionados desde aquí",
openAsset: "Abrir {{name}}",
editLink: "Editar el enlace con {{name}}",
unlink: "Desvincular {{name}}",
treeLoading: "Cargando…",
treeThisAsset: "Este activo",
treeChildren_one: "{{count}} hijo",
treeChildren_other: "{{count}} hijos",
riskRelevant: "Relevante para el riesgo",
informational: "Informativa",
linkCreated: "Enlace creado",
linkAnother: "Vincular otro",
done: "Listo",
type: {
contains: "Contiene",
part_of: "Parte de",
located_in: "Ubicado en",
depends_on: "Depende de",
supports: "Soporta",
connected_to: "Conectado a",
serves: "Sirve a",
powered_by: "Alimentado por",
monitored_by: "Supervisado por",
associated_with: "Asociado con",
backup_for: "Respaldo de",
replacement_for: "Sustituto de",
assigned_to: "Asignado a",
installed_in: "Instalado en",
maintained_with: "Mantenido con",
possible_duplicate_of: "Posible duplicado de",
duplicate_of: "Duplicado de",
merged_into: "Fusionado en",
},
verb: {
contains: "contiene",
part_of: "es parte de",
located_in: "está ubicado en",
depends_on: "depende de",
supports: "soporta",
connected_to: "está conectado a",
serves: "sirve a",
powered_by: "está alimentado por",
monitored_by: "está supervisado por",
associated_with: "está asociado con",
backup_for: "es un respaldo de",
replacement_for: "es un sustituto de",
assigned_to: "está asignado a",
installed_in: "está instalado en",
maintained_with: "se mantiene con",
possible_duplicate_of: "puede ser un duplicado de",
duplicate_of: "es un duplicado de",
merged_into: "se fusionó en",
},
category: {
hierarchy: "Jerarquía",
dependency: "Dependencias",
association: "Relacionados",
duplicate: "Duplicados",
},
propagation: {
none: "Ninguna",
informational: "Informativa",
contributes_to_parent: "Contribuye al superior",
contributes_to_dependent: "Contribuye al dependiente",
bidirectional_warning: "Aviso bidireccional",
},
form: {
addTitle: "Añadir relación",
editTitle: "Editar relación",
close: "Cerrar",
relatedAsset: "Activo relacionado",
chooseRelated: "Elija el activo con el que se relaciona este",
choose: "Elegir",
change: "Cambiar",
done: "Listo",
edit: "Editar",
relationshipType: "Tipo de relación",
swap: "Invertir",
swapA11y: "Invertir la dirección",
riskAndNotes: "Riesgo y notas",
criticality: "Criticidad",
countsTowardsRisk: "Cuenta para el riesgo",
riskRelevant: "Relevante para el riesgo",
informationalOnly: "Solo informativa",
informationalHint: "Las relaciones «{{type}}» son informativas.",
propagation: "Propagación del riesgo",
reasonPlaceholder: "Motivo de la criticidad (opcional)",
reasonA11y: "Motivo de la criticidad",
notesPlaceholder: "Notas (opcional)",
notesA11y: "Notas",
notes: "Notas",
cancel: "Cancelar",
add: "Añadir relación",
save: "Guardar cambios",
saving: "Guardando...",
and: "{{a}} y {{b}}",
selectAssetTitle: "Seleccione un activo",
selectAssetBody: "Elija un activo para relacionar.",
couldNotAdd: "No se pudo añadir la relación",
tryAgain: "Inténtelo de nuevo.",
},
edge: {
added: "Añadida el {{date}}",
edit: "Editar",
remove: "Eliminar",
close: "Cerrar",
},
picker: {
  addAsset: "Añadir un activo",
title: "Activo",
relatedTitle: "Activo relacionado",
searchPlaceholder: "Buscar por nombre, sitio o ID…",
searchA11y: "Buscar activos",
clearSearch: "Borrar la búsqueda",
allTypes: "Todos los tipos",
searching: "Buscando en todos los activos…",
noneYet: "Aún no hay activos.",
noMatchHint: "Ningún activo coincide. Pruebe otro nombre o quite el filtro de tipo.",
noMatch: "Ningún activo coincide.",
showingFirst: "Se muestran los primeros {{shown}} de {{total}}. Siga escribiendo para acotar.",
noAsset: "Sin activo",
clearSelection: "Borrar la selección",
done: "Listo",
close: "Cerrar",
chooseAsset: "Elija un activo",
changeA11y: "Activo: {{name}}. Cambiar",
},
hops_many: "{{count}} niveles",
mapAssets_many: "{{count}} activos",
mapLinks_many: "{{count}} enlaces",
treeChildren_many: "{{count}} hijos",
},
relationshipNode: {
current: "Activo actual",
unscored: "Estado sin puntuar",
loadingImpact: "Cargando el impacto…",
impacts_one: "Afecta a {{count}} activo relacionado",
impacts_other: "Afecta a {{count}} activos relacionados",
open: "Abrir activo",
addRelationship: "Añadir relación",
viewWork: "Ver trabajo afectado",
close: "Cerrar",
impacts_many: "Afecta a {{count}} activos relacionados",
},
documentsSection: {
  editDetails: "Editar detalles",
statusAll: "Todos",
statusExpired: "Caducado",
statusExpiringSoon: "Caduca pronto",
statusValid: "Válido",
statusPending: "Pendiente",
statusRejected: "Rechazado",
statusSupersededOrUndated: "Sustituido o sin fecha",
typeAll: "Todos los tipos",
typeCertificates: "Certificados",
typeWarranty: "Garantía",
typeCompliance: "Cumplimiento",
typeGeneral: "General",
viewList: "Lista",
viewTimeline: "Línea de tiempo",
viewCalendar: "Calendario",
viewLabel: "Vista",
loadingDocumentsA11y: "Cargando documentos",
loadingDocumentsText: "Cargando documentos…",
addDocumentA11y: "Añadir documento",
tryLoadingAgainA11y: "Intente cargar documentos nuevamente",
refineDocumentsA11y: "Refinar documentos",
searchDocumentsA11y: "Buscar documentos",
clearSearchA11y: "Borrar búsqueda",
refineDocumentsTitle: "Refinar documentos",
rejectionReasonA11y: "Motivo del rechazo",
reasonPlaceholder: "Motivo",
validateInTheirPlace: "Validar en su lugar",
openFile: "Abrir archivo",
validate: "Validar",
renew: "Renovar",
replace: "Reemplazar",
reject: "Rechazar",
startInspection: "Iniciar inspección",
createJob: "Crear orden de trabajo",
planRenewal: "Planificar su renovación",
history: "Historial",
closeA11y: "Cerrar",
metaIssued: "Emitido",
metaExpires: "Vence",
metaReminder: "Recordatorio",
metaReminderDays: "{{days}} días",
metaSource: "Origen",
metaFile: "Archivo",
metaValidatedBy: "Validado por",
metaPrevious: "Anterior",
metaNext: "Siguiente",
showPreviousMonthA11y: "Mostrar el mes anterior",
showNextMonthA11y: "Mostrar el próximo mes",
showTodayA11y: "Mostrar hoy",
dateHintA11y: "Muestra los documentos emitidos o que vencen en esta fecha",
documentHistoryTitle: "Historial del documento",
noRenewalHistory: "Aún no hay historial de renovación.",
historyEntry: "{{index}}. {{title}} - {{date}} - {{status}}",
historyCurrentStatus: "actual",
validateDocumentTitle: "Validar documento",
validateDocumentBody: "¿Validar \"{{title}}\" y marcarlo como activo?",
cancel: "Cancelar",
reasonRequiredTitle: "Motivo requerido",
reasonRequiredBody: "Introduzca un motivo de rechazo antes de rechazar este documento.",
pageTitle: "Documentos",
pageSub: "Archivos, certificados y garantías guardados en este activo.",
loadErrorText: "No se pudieron cargar los documentos",
emptyText: "Aún no hay documentos",
emptySub: "Aquí se guardan los certificados, garantías y manuales de este activo, con sus fechas de vencimiento controladas.",
tryAgain: "Intentar de nuevo",
addDocumentButton: "Añadir documento",
viewOptionA11y: "Vista {{label}}",
refine: "Refinar",
searchPlaceholder: "Buscar documentos…",
rejectDocumentTitle: "Rechazar documento",
rejectDocumentBody: "Ingrese el motivo por el cual este documento no se puede validar.",
openDocumentA11y: "Abrir {{title}}",
rejectionReasonPrefix: "Motivo del rechazo: {{reason}}",
noDocumentDates: "Sin fechas de documentos",
documentDateCount_one: "{{count}} fecha del documento",
documentDateCount_other: "{{count}} fechas de documentos",
dayCellA11y: "{{dateLabel}}. {{eventLabel}}.",
statusPendingValidation: "Pendiente de validación",
statusSupersededLabel: "Sustituido",
statusNoExpiryRecorded: "No se ha registrado ningún vencimiento",
statusEvidenceMissing: "Falta evidencia",
kindIssued: "Emitido",
kindAdded: "Añadido",
kindExpires: "Vence",
openDocumentWithStatusA11y: "Abra {{title}}. {{status}}.",
issuedOn: "Emitido {{date}}",
addedOn: "Añadido el {{date}}",
expiresOnSuffix: " · Vence {{date}}",
noExpiryRecordedSuffix: " · No se registra vencimiento",
expiresLowerSuffix: " → caduca {{date}}",
noExpiryRecordedLowerSuffix: " · no se registra caducidad",
today: "Hoy",
documentDateCount_many: "{{count}} fechas de documentos",
},
guideMeSheet: {
subtitle: "Elija algo que configurar en este activo. Le señalamos dónde tocar, paso a paso.",
},
graphInspector: {
selectedLink: "Enlace seleccionado",
},
decommissionSheet: {
title: "Poner fuera de servicio",
cancelA11y: "Cancelar la puesta fuera de servicio",
reasonLabel: "¿Por qué sale de servicio?",
outOfServiceFromLabel: "Fuera de servicio desde",
noteLabel: "Nota",
notePlaceholder: "Lo que el equipo debe saber; p. ej., intercambiador de calor agrietado, recambio pedido.",
noteA11y: "Nota de puesta fuera de servicio",
makeSafeFirstTitle: "Hazlo seguro primero",
makeSafeFirstBodyOn_one: "Genera una orden de trabajo con {{count}} paso de puesta en seguridad como verificación posterior. El activo deja el servicio cuando se verifica esa orden de trabajo.",
makeSafeFirstBodyOn_many: "Genera una orden de trabajo con {{count}} pasos de puesta en seguridad como verificación posterior. El activo deja el servicio cuando se verifica esa orden de trabajo.",
makeSafeFirstBodyOn_other: "Genera una orden de trabajo con {{count}} pasos de puesta en seguridad como verificación posterior. El activo deja el servicio cuando se verifica esa orden de trabajo.",
makeSafeFirstBodyOff: "Sin orden de trabajo. El activo deja de estar en servicio ahora; agregue una nota que diga quién decidió.",
makeSafeSwitchA11y: "Generar una orden de trabajo de seguridad antes de que el activo deje el servicio",
confirmRaise: "Generar la orden de trabajo de puesta en seguridad",
confirmTakeOut: "Poner fuera de servicio ahora",
},
dataQuality: {
bandComplete: "Perfil completo",
bandPartial: "Perfil parcial",
bandMissing: "Faltan detalles",
title: "Perfil de activo",
subtitleAllComplete_one: "El campo de perfil aplicable ({{total}}) está completo.",
subtitleAllComplete_other: "Los {{total}} campos de perfil aplicables están completos.",
subtitleAddLead: "Añadir {{label}} — {{unlock}}.",
subtitleAddMissing: "Agregue los detalles estructurados que faltan para completar este perfil de activo.",
addGapA11y: "Agregar {{label}} — {{unlock}}",
applySuggestions_one: "Aplicar {{count}} sugerencia de IA",
applySuggestions_other: "Aplicar {{count}} sugerencias de IA",
confidenceMediumLabel: "Confianza media",
confidenceMediumBody: "La IA está trabajando con detalles limitados en este activo.",
confidenceLowLabel: "Confianza baja",
confidenceLowBody: "Este activo tiene pocos datos estructurados, así que trate la salida de IA como punto de partida.",
confidenceA11y: "{{label}}. {{body}} Mejorar la calidad de los datos.",
confidenceBodySuffix: "{{body}} Mejorar datos →",
subtitleAllComplete_many: "Los {{total}} campos de perfil aplicables están completos.",
applySuggestions_many: "Aplicar {{count}} sugerencias de IA",
},
activitySection: {
who: "Quién: {{name}}",
when: "Cuándo: {{when}}",
refineActivity: "Refinar actividad",
refine: "Refinar",
searchActivityPlaceholder: "Buscar actividad…",
searchActivityA11y: "Buscar actividad",
clearSearchA11y: "Borrar búsqueda",
hideSearchA11y: "Ocultar búsqueda",
noActivityOnDate: "No hay actividad en esta fecha",
noActivityHint: "Elige otro día o cambia Refinar o la búsqueda.",
view: "Vista",
timeline: "Línea de tiempo",
calendar: "Calendario",
status: "Estado",
all: "Todos",
outstanding: "Pendiente",
planned: "Planificada",
completed: "Completado",
inspections: "Inspecciones",
jobs: "Órdenes de trabajo",
documents: "Documentos",
},
actionsSection: {
uploadDocumentA11y: "Subir documento",
uploadDoc: "Subir documento",
},
portfolioGraphPanel: {
couldNotLinkTitle: "No se pudo vincular",
createRelationshipFailed: "No se pudo crear la relación.",
couldNotRemoveTitle: "No se pudo eliminar",
failed: "Error.",
emptyTitle: "No hay activos para visualizar",
emptySub: "Crea tu primer activo para ver la red.",
useListView: "Usar vista de lista",
},
portfolioContextualBar: {
linkTypeHeader: "Tipo de vínculo · {{source}} → {{target}}",
defaultSourceName: "origen",
defaultTargetName: "objetivo",
pickTypeHint: "Elija un tipo o use Más opciones para obtener detalles completos.",
moreOptions: "Más opciones",
editOnSource: "Editar en el origen",
criticalityBadge: "Criticidad {{criticality}}",
impactsRelated_one: "Afecta a {{count}} relacionado",
impactsRelated_many: "Afecta a {{count}} relacionados",
impactsRelated_other: "Afecta a {{count}} relacionados",
connectFromHere: "Conectar desde aquí",
},
portfolioGraphContextRow: {
exit: "Salir",
connect: "Conectar",
},
listRow: {
canRequestWork: "Puede solicitar trabajo",
readOnly: "Sólo lectura",
overdue: "Vencido",
next: "Siguiente",
nextStepLabel: "{{prefix}}: {{scheduleLabel}} {{time}}",
recommendedRaiseJob: "Recomendado: Generar orden de trabajo",
recommendedInspect: "Recomendado: Inspeccionar",
healthSuffix: "Salud: {{status}}",
needsAttention: "necesita atención",
openNextStep: "Abrir {{label}}",
recommendRaiseJobA11y: "Siguiente acción recomendada: generar una orden de trabajo",
recommendInspectA11y: "Siguiente acción recomendada: iniciar una inspección",
directionsTo: "Cómo llegar a {{name}}",
relationshipsFor: "Relaciones de {{name}}",
},
shareSection: {
invitePending: "Invitación pendiente",
inviteRequired: "Invitación necesaria",
active: "Activa",
title: "Contactos compartidos",
subtitle: "Todas las personas enumeradas aquí pueden abrir este activo en el espacio de trabajo compartido según su función y permisos.",
shareWithContact: "Compartir con contacto",
loading: "Cargando contactos compartidos…",
empty: "Ningún contacto tiene acceso a este activo todavía. Compártelo con un contacto para que pueda solicitar inspecciones o proponer órdenes de trabajo.",
linkedContactFallback: "Contacto vinculado",
noRelationshipLinked: "No hay relación de activos vinculada",
collaborationRole: "Rol de colaboración: {{role}}",
collaborationRoleWithStatus: "Rol de colaboración: {{role}} · {{status}}",
canView: "Puede ver",
lockedFeatureName: "Compartir con contactos",
canRequestInspection: "Puede solicitar inspección",
canProposeJob: "Puede proponer orden de trabajo.",
yes: "Sí",
no: "No",
workspaceVisibility: "Visibilidad del espacio de trabajo: {{detail}}",
openRequests: "Solicitudes abiertas: {{count}}",
openRequestsWithLast: "Solicitudes abiertas: {{count}} · Última solicitud {{date}}",
openRequestsNoneYet: "Solicitudes abiertas: {{count}} · Aún no hay solicitudes",
inviteSentResendHint: "Invitación enviada. Reenvíela si no la han recibido.",
inviteSendHint: "Enviar invitación para que puedan vincular su cuenta y acceder a este activo.",
working: "trabajando...",
resendInvite: "Reenviar invitación",
sendInvite: "Enviar invitación",
editPermissions: "Editar permisos",
revokeAccess: "Revocar acceso",
viewContact: "Ver contacto",
viewRequests: "Ver solicitudes",
},
listSignalPills: {
riskDefaultLabel: "Riesgo",
overdueJob_one: "orden de trabajo vencida",
overdueJob_other: "órdenes de trabajo vencidas",
complianceLabel: "Cumplimiento",
overdueJob_many: "órdenes de trabajo vencidas",
},
overviewQuickActions: {
defaultTitle: "Acciones rápidas",
},
imageCarousel: {
photoPosition: "foto {{current}} de {{total}}",
photoSingle: "foto",
labeledPosition: "{{label}}, {{position}}",
viewFullSize: "{{label}}. Ver tamaño completo",
previousPhoto: "Foto anterior",
nextPhoto: "Siguiente foto",
goToPhoto: "Ir a la foto {{current}} de {{total}}",
},
imageLightbox: {
defaultTitle: "Fotos de activos",
closeA11y: "Cerrar",
},
conditionAccordion: {
a11yLabelExpanded: "{{title}}, ampliado",
a11yLabelCollapsed: "{{title}}, colapsado",
},
impactChip: {
a11yLabel_one: "Este activo alimenta {{count}} activo relacionado: vea su trabajo",
a11yLabel_other: "Este activo alimenta {{count}} activos relacionados: vea su trabajo",
text_one: "Alimenta {{count}} activo relacionado: los problemas aquí pueden afectar a su trabajo",
text_other: "Alimenta {{count}} activos relacionados: los problemas aquí pueden afectar a su trabajo",
a11yLabel_many: "Este activo alimenta {{count}} activos relacionados: vea su trabajo",
text_many: "Alimenta {{count}} activos relacionados: los problemas aquí pueden afectar a su trabajo",
},
assetDetailsPanel: {
roomCounts: "Recuento de habitaciones",
bedrooms: "Dormitorios",
bathrooms: "Baños",
kitchens: "Cocinas",
livingRooms: "Salas de estar",
diningRooms: "Comedores",
utilityRooms: "Cuartos de servicio",
garages: "Garajes",
parkingSpaces: "Plazas de aparcamiento",
amenities: "Comodidades",
garden: "Jardín",
driveway: "Entrada de coches",
balcony: "Balcón",
ensuite: "Baño privado",
outbuilding: "Edificio auxiliar",
basement: "Sótano",
loft: "Desván",
furnishing: "Mobiliario",
systems: "Sistemas",
facilityCounts: "Recuentos de instalaciones",
units: "Unidades",
toilets: "Aseos",
kitchenettes: "Cocinas pequeñas",
loadingBays: "Muelles de carga",
lifts: "Ascensores",
facilityFeatures: "Características de la instalación",
reception: "Recepción",
plantRoom: "Sala de máquinas",
fireAlarm: "Alarma de incendios",
sprinklers: "Aspersores",
accessControl: "Control de acceso",
shutterDoors: "Puertas enrollables",
condition: "Condición",
capacity: "Capacidad",
seatingCapacity: "Capacidad de asientos",
loadCapacity: "Capacidad de carga",
datesService: "Fechas y servicio",
year: "Año",
yearPlaceholder: "p.ej. 2024",
odometer: "Cuentakilómetros",
roadCompliance: "Cumplimiento vial",
capacityElectrical: "Capacidad y eléctrico",
voltage: "Tensión",
phase: "Fase",
capacityValue: "Valor de capacidad",
serviceSchedule: "Calendario de servicio",
serviceIntervalDays: "Intervalo de servicio (días)",
details: "Detalles",
coreDetails: "Detalles principales",
propertyDetails: "Detalles de la propiedad",
propertyDetailsHint: "Elija primero una categoría de propiedad para desbloquear solo las secciones relevantes.",
retrySavingDetails: "Reintentar guardar detalles",
structuredDetailsFor: "Detalles estructurados para este {{assetType}}.",
noStructuredDetails: "Aún no se han confirmado detalles estructurados.",
assetProfileDetails: "Detalles del perfil de activos",
coreDetailsConfirmed: "Los detalles principales están confirmados para este activo.",
hiddenUntilPropertyChosen: "El recuento de habitaciones, los detalles de las instalaciones y los campos de IA permanecen ocultos hasta que se elige el tipo de propiedad.",
unsavedChanges: "Cambios no guardados…",
saving: "Guardando…",
saved: "Guardado",
couldNotSaveChanges: "No se pudieron guardar los cambios.",
changesSaveAutomatically: "Los cambios se guardan automáticamente.",
retry: "Reintentar",
coreFieldsFilled: "{{completed}} de {{total}} campos principales completados",
stillMissing: "Aún falta: {{labels}}",
applySeededSuggestions_one: "Aplicar {{count}} sugerencia inicial",
applySeededSuggestions_other: "Aplicar {{count}} sugerencias iniciales",
applySeededSuggestionsZero: "Aplicar sugerencias iniciales",
appliedSuggestions_one: "Se aplicó {{count}} sugerencia: revise los campos a continuación; se guardan automáticamente.",
appliedSuggestions_other: "Se aplicaron {{count}} sugerencias: revise los campos a continuación; se guardan automáticamente.",
noSuggestionsToFill: "Estos detalles ya coinciden con todas las sugerencias iniciales: no hay nada que completar.",
lifecycle: "Ciclo de vida",
criticality: "Criticidad",
compliance: "Cumplimiento",
furnishedStatus: "Estado del mobiliario",
location: "Ubicación",
otherCategory: "Otra categoría",
subtypeDetailLegacy: "Detalle del subtipo (antiguo)",
yes: "Sí",
no: "No",
unknown: "Desconocido",
viewQrCode: "Ver código QR",
hideQrCode: "Ocultar código QR",
applySeededSuggestions_many: "Aplicar {{count}} sugerencias iniciales",
appliedSuggestions_many: "Se aplicaron {{count}} sugerencias: revise los campos a continuación; se guardan automáticamente.",
},
imageDrawModal: {
colorRed: "Rojo",
colorAmber: "Ámbar",
colorGreen: "Verde",
colorWhite: "Blanco",
toolDraw: "Dibujar",
toolArrow: "Flecha",
toolBox: "Recuadro",
toolCircle: "Círculo",
toolText: "Texto",
couldNotSaveMarkupTitle: "No se pudo guardar el marcado",
couldNotSaveMarkupBody: "La foto se agregó sin el marcado.",
clearAllMarkupTitle: "¿Borrar todas las marcas?",
clearAllMarkupBody: "Esto elimina todas las marcas de la foto.",
cancel: "Cancelar",
clear: "Borrar",
cancelMarkupA11y: "Cancelar anotación",
doneA11y: "Hecho",
done: "Hecho",
markupTitle: "Marcado",
labelThisPointPlaceholder: "Etiqueta este punto",
markupTextA11y: "Texto de marcado",
addTextA11y: "Agregar texto",
add: "Agregar",
cancelTextA11y: "Cancelar texto",
undoLastMarkA11y: "Deshacer la última marca",
undo: "Deshacer",
clearAllMarkupA11y: "Borrar todo el marcado",
},
qrScanner: {
enterCodeTitle: "Introducir código",
enterCodeBody: "Pega o escribe un valor de código QR.",
qrCodeTitle: "Código QR",
qrCodeValueA11y: "Valor del código QR",
webUnavailableMessage: "El escaneo de la cámara no está disponible en la web. Pegue un valor de código QR a continuación o use la aplicación en su teléfono para escanear.",
pasteOrTypePlaceholder: "Pegar o escribir el valor del código QR...",
resolveCode: "Buscar el código",
cancel: "Cancelar",
requestingPermission: "Solicitando permiso de cámara…",
permissionRequiredTitle: "Se requiere permiso de cámara",
permissionRequiredMessage: "Se necesita acceso a la cámara para escanear códigos QR. Activa los permisos de la cámara en los ajustes de tu dispositivo.",
grantPermission: "Conceder permiso",
typeCodeUnderQrPlaceholder: "O escriba el código impreso debajo de QR...",
scanQrCodeTitle: "Escanear código QR",
closeScannerA11y: "Cerrar escáner",
typeCodeUnderQrShortPlaceholder: "Escriba el código impreso debajo de QR",
positionQrHint: "Coloque el código QR dentro del marco.",
backToCameraA11y: "De vuelta a la cámara",
enterCodeInsteadA11y: "Introduzca el código en su lugar",
backToCamera: "De vuelta a la cámara",
cantScanEnterCode: "¿No puedes escanearlo? Introduzca el código en su lugar",
scanned: "Escaneado",
},
measureView: {
spokenClear: "Borrar",
spokenDivide: "Dividir",
spokenMultiply: "Multiplicar",
spokenBackspace: "Retroceso",
spokenMinus: "Menos",
spokenPlus: "Más",
spokenEquals: "Igual",
spokenDecimalPoint: "Punto decimal",
captureReading: "Capturar lectura",
},
dictateView: {
stopDictation: "Detener dictado",
startDictation: "Iniciar dictado",
listening: "Escuchando…",
stopped: "Detenido",
tapToTalk: "Toca para hablar",
speakNaturally: "Hable con naturalidad: la IA creará el registro adecuado.",
transcriptPlaceholder: "Su transcripción aparecerá aquí mientras habla.",
clear: "Borrar",
useTranscript: "Usar transcripción",
},
dictateCapture: {
issueDraftLabel: "Borrador de incidencia",
issueDraftDetail: "Parece un defecto: Copilot puede registrar una incidencia.",
noteLabel: "Nota",
noteDetail: "Capturado como una nota simple adjunta al contexto actual.",
},
omniCaptureSheet: {
modePhoto: "Foto",
modePhotoHint: "Toma o elige una foto. Título sugerido automáticamente.",
modeDictate: "Dictar",
modeDictateHint: "Cuéntelo hablando; la IA crea el registro adecuado.",
modeScan: "Escanear QR",
modeScanHint: "Ir al activo vinculado.",
modeMeasure: "Medir",
modeMeasureHint: "Capture una lectura o haga un cálculo rápido.",
modeNote: "Nota",
modeNoteHint: "Nota de texto sin formato adjunta al contexto.",
defaultTitle: "Capturar",
backA11y: "Atrás",
closeA11y: "Cerrar",
forScope: "Para: {{scope}}",
noteA11y: "Nota",
notePlaceholder: "Añadir una nota...",
saveNoteA11y: "Guardar nota",
saveNote: "Guardar nota",
},
workLocationFlag: {
defaultAssetName: "el activo",
locationCheckWaiting: "Verificación de ubicación en espera",
recordedAway: "Registrado lejos del activo",
carriedOutWithDistance: "Este trabajo se realizó a {{distance}} de donde está registrado {{name}}.",
carriedOutNoDistance: "Este trabajo se realizó lejos de donde está registrado {{name}}.",
pendingSuffix: " El equipo que gestiona el activo aún no ha respondido.",
reviewedSuffix: " Revisado: el activo no se ha movido.",
},
what3wordsField: {
useSuggestion: "Utilice {{words}}",
},
assetMoveSheet: {
reasonMoved: "Se movió",
reasonMovedHint: "El activo está físicamente en algún lugar nuevo.",
reasonCorrected: "Estaba mal",
reasonCorrectedHint: "El activo nunca estuvo donde decía el registro.",
title: "Mover {{assetName}}",
whatHappened: "¿Qué pasó?",
whereIsItNow: "¿Dónde está ahora?",
whenDidItMove: "¿Cuándo se movió?",
today: "Hoy",
yesterday: "Ayer",
lastWeek: "La semana pasada",
overAMonthAgo: "Hace más de un mes",
noteOptional: "Nota (opcional)",
notePlaceholder: "por ej. Reubicado en la sala de máquinas del subsótano.",
recordTheMove: "Registrar el traslado",
correctTheLocation: "Corregir la ubicación",
cancel: "Cancelar",
},
locationClaimReview: {
fieldResponseAssetIsHere: "La persona en el sitio confirmó que el activo está allí.",
fieldResponseAssetNotHere: "La persona en el sitio dijo que el activo NO está allí",
fieldResponseUnsure: "La persona en el sitio no estaba segura",
fieldResponseDeviceReported: "Un dispositivo conectado informó el activo desde allí; a nadie se le preguntó",
defaultAssetName: "Este activo",
stillWhereWeThinkTitle: "¿{{name}} sigue donde pensamos?",
unknownDistance: "Distancia desconocida",
betweenRecordedAndSource: "entre la ubicación registrada y {{source}}",
updateAssetLocation: "Actualizar la ubicación del activo",
hasNotMoved: "No, no se ha movido",
whyNotMovedTitle: "¿Por qué no se ha movido?",
whyNotMovedMessage: "Esto se mantiene en la inspección u orden de trabajo, para que la persona que lo reportó pueda ver lo que se decidió.",
whyNotMovedPlaceholder: "por ej. El activo todavía se encuentra en la sala de máquinas; el ingeniero asistió al sitio equivocado",
rejectAndFlag: "Rechazar y marcar el trabajo",
},
locationField: {
defaultAddressLabel: "Dirección",
searchAddressPlaceholder: "Buscar dirección…",
pinSavedAccurate: "Pin guardado, con una precisión de aproximadamente {{meters}} m",
pinSaved: "Ubicación guardada",
level: "Nivel",
levelIndexPlaceholder: "0 = planta baja, -2 = sótano 2",
levelName: "Nombre del nivel",
levelNamePlaceholder: "p. ej., Sótano 2, Azotea",
depthLabel: "Profundidad bajo tierra (metros)",
depthPlaceholder: "por ej. 3.2 para una tubería principal enterrada",
doesItMove: "¿Se mueve?",
useCurrentLocation: "Usar la ubicación actual",
},
locationCheckPrompt: {
isHereTitle: "¿Está aquí {{assetName}}?",
assetIsHere: "Sí, el activo está aquí.",
assetNotHere: "No, el activo está en otro lugar",
unsure: "No estoy seguro",
explainWithDistance: "Este trabajo se registró a {{distance}} de donde consta {{assetName}}.",
explainNoDistance: "Este trabajo se registró lejos de donde consta {{assetName}}.",
reassure: "Su respuesta va para el equipo que gestiona este activo. Nada cambia hasta que lo confirmen.",
},
actionPickerHost: {
share: {
title: "Compartir un activo",
subtitle: "Elija el activo a compartir.",
},
report: {
title: "Informar un problema",
subtitle: "Elija el activo sobre el que informar un problema.",
},
meterReading: {
title: "Registrar una lectura",
subtitle: "Elija el activo al que pertenece el medidor.",
},
maintenancePlan: {
title: "Agregar un plan de mantenimiento",
subtitle: "Elija el activo para el que es el plan.",
},
inspection: {
title: "Iniciar una inspección",
subtitle: "Elija el activo que va a inspeccionar.",
},
job: {
title: "Registrar un trabajo",
subtitle: "Elija el activo al que corresponde el trabajo.",
},
},
assetDetailScreen: {
  contactInteraction: {
    unknownName: "Desconocido",
    approvalReceived: "Aprobación recibida",
    reportShared: "Informe compartido",
  },
  lastInspectionOutcome: {
    inProgress: "Inspección en curso",
    completed: "Última inspección completada",
    failed: "No superó la última inspección",
  },
  kpiInfo: {
    profileA11y: "Datos completos al {{score}} %. Abre los detalles.",
    profilePill: "Datos completos al {{score}} %",
    healthA11y: "Salud operativa: {{status}}",
    noSchedule: "Nada programado",
    doneCount: "Hechas: {{n}}",
    scheduledCount: "Programados: {{n}}",
    overdueCount: "Atrasados: {{n}}",
    noOpenJobs: "Sin trabajos abiertos",
    openJobsBasedOn: "{{open}} de {{total}} trabajos de este activo",
    openJobsDescription: "Trabajos de este activo que aún no se han verificado ni cancelado. Un trabajo pendiente de aprobación sigue contando.",
    complianceBasedOn: "Documentos guardados: {{n}}",
    complianceGuidance: "Toca el recuadro para ver cada documento.",
    complianceDescription: "Una puntuación de 0 a 100 para los certificados y documentos que necesita este tipo de activo; baja cuando se acerca su caducidad.",
    riskEmpty: "Aún no hay inspecciones, así que no se puede calcular el riesgo.",
    riskBasedOn: "Última inspección: {{date}}",
    riskGuidance: "Toca el recuadro para ver cómo se calculó la puntuación.",
    riskDescription: "La probabilidad de un problema por su gravedad, cada una de 1 a 5 según la última inspección y la importancia del activo. 25 es el máximo; 15 o más es alto.",
    healthBasedOn: "{{open}} trabajos abiertos · {{overdue}} atrasados · {{failed}} puntos fallidos · última inspección {{last}}",
    healthEmpty: "Este activo aún no tiene inspecciones, certificados ni trabajos.",
    healthGuidance: "Toca el recuadro para ver qué cambió la puntuación y qué hacer después.",
    healthDescription: "Salud operativa: una puntuación de 0 a 100 basada en certificados, resultados de inspección, trabajos abiertos y atrasados, y la antigüedad del activo. 80 o más es Bueno; de 55 a 79, Vigilar; menos de 55, Malo. La valoración de estado de 1 a 5 de las inspecciones es una medida distinta.",
    never: "nunca",
    noInspectionYet: "Sin inspección aún",
    nothingYet: "Aún no hay datos",
    unavailable: "No se pudo cargar",
  },
  approver: {
    anyoneInTeam: "Cualquiera del equipo",
    anyoneIn: "Cualquiera de {{team}}",
  },
  header: {
    subtitle: "{{lifecycle}} · {{site}} · Propietario {{owner}}",
    noSite: "Sin sitio todavía",
  },
  blocked: {
    archivedNoJobs: "Los activos archivados no admiten trabajos nuevos.",
    retiredNoJobs: "Los activos retirados definitivamente no admiten trabajos nuevos.",
    archivedNoInspections: "Los activos archivados no admiten inspecciones nuevas.",
    retiredNoInspections: "Los activos retirados definitivamente no admiten inspecciones nuevas.",
    decommissionedBody: "Primero recupéralo: toca Volver a poner en servicio arriba en este activo. Así empieza una inspección y luego los trabajos que detecte.",
    plannedBody: "Primero ponlo en servicio: toca Poner en servicio arriba en este activo. Así empieza una inspección y luego los trabajos que detecte.",
    archivedBody: "Puedes verlo y editarlo. Para añadir inspecciones o trabajos, desarchívalo desde el menú ⋯.",
    retiredBody: "Puedes consultar su historial, pero no añadir inspecciones ni trabajos. Un propietario o administrador puede restaurarlo desde el menú ⋯.",
    archivedTitle: "Este activo está archivado",
    retiredTitle: "Este activo está retirado definitivamente",
  },
  commissionCase: {
    returnStep: "Todo está verificado. Toca {{label}}.",
    fixStep: "Termina y verifica cada trabajo de la inspección. Después podrás volver a ponerlo en servicio.",
    inspectStep: "Siguiente: toca Iniciar la inspección. Después vendrán los trabajos que detecte.",
    recommissioningTitle: "Vuelta al servicio",
    commissioningTitle: "Puesta en servicio",
  },
  teamMove: {
    movedToPersonal: "Movido a Personal. Ahora solo tú puedes verlo.",
    movedToTeam: "Movido a {{team}}. Todo el equipo puede verlo y trabajar en él.",
  },
  knowledgeShare: {
    openLink: "Cualquiera con el enlace",
    contact: "Contacto",
    wholeLibrary: "Toda la biblioteca",
    oneItem: "Un elemento",
    failedBody: "Compruebe la conexión e inténtelo de nuevo.",
    failedTitle: "Enlace no creado",
    chooseContactBody: "Toque Elegir contacto y seleccione para quién es el enlace.",
    chooseContactTitle: "Elija un contacto",
    noMailBody: "El enlace está copiado. Péguelo en un mensaje.",
    noMailTitle: "Sin app de correo",
    emailBody: "Abra este enlace para leerla: {{url}}",
    emailSubject: "Información compartida con usted",
    done: "Listo",
    emailIt: "Correo a {{name}}",
    copiedBodyEmail: "Toque Correo para enviarlo a {{name}} desde su app de correo, o péguelo en cualquier mensaje.",
    copiedBody: "Péguelo en un mensaje para {{name}}. No se envía nada hasta que lo haga.",
    linkTitle: "Enlace para compartir",
    copiedTitle: "Enlace copiado",
    hintItem: "Elija para quién es el enlace. Cualquiera que lo tenga puede abrir este elemento, así que envíelo solo a esa persona. Puede detener un enlace abajo cuando quiera.",
    hintLibrary: "Elija para quién es el enlace. Cualquiera que lo tenga puede abrir todo el conocimiento de este activo, así que envíelo solo a esa persona. Puede detener un enlace abajo cuando quiera.",
    invalidUrlBody: "Escriba la dirección web completa, empezando por https://, por ejemplo https://example.com/manual.",
    invalidUrlTitle: "Revise la dirección web",
    saving: "Guardando…",
    save: "Guardar",
  },
loadingDetails: "Cargando detalles del activo...",
assetNotFound: "Activo no encontrado",
loadErrorTitleRetryable: "No pudimos cargar este activo.",
loadErrorTitleFinal: "Este activo no se puede mostrar.",
assetOptionsA11y: "Opciones de activos",
changeApproverA11y: "Cambiar quién aprueba el trabajo en este activo",
change: "Cambiar",
createdBanner: {
title: "Activo creado",
subtitle: "Inicie la inspección recomendada, informe un problema o agregue detalles opcionales.",
inspectNow: "Inspeccionar ahora",
inspectNowA11y: "Inspeccione este activo ahora",
reportIssue: "Informar de un problema",
reportIssueA11y: "Informar un problema para este activo",
addDetails: "Añadir detalles",
addDetailsA11y: "Agregar detalles de activos opcionales",
share: "Compartir",
shareA11y: "Compartir este activo con un contacto",
dismissA11y: "Descartar",
},
capture: {
notSavedTitle: "Captura no guardada",
notFoundBody: "No se pudo encontrar esa captura. Vuelva a capturarla.",
mismatchBody: "Esta captura no coincide con el activo actual.",
photoAdded: "Foto agregada al activo",
notesUpdated: "Notas de activos actualizadas",
measurementAdded: "Medición añadida a las notas del activo",
notSupportedTitle: "Captura no compatible",
notSupportedBody: "El escaneo QR se gestiona desde el escáner; no se guarda en los activos.",
noPhotoCaptured: "No se capturó ninguna foto.",
signInRequiredForPhotos: "Debes iniciar sesión para guardar fotos.",
noNoteCaptured: "No se capturó ningún texto de nota.",
modeNotSupported: "Este modo de captura no es compatible con activos.",
},
tryAgain: "Inténtelo de nuevo.",
contactsAlerts: {
  pickerCreateLabel: "Crear y vincular contacto",
  pickerLinkTitle: "Vincular un contacto",
  pickerShareTitle: "Compartir con un contacto",
  defaultInviterName: "Un compañero",
  linkedBody: "{{name}} ya está vinculado a este activo.",
  sharedAndInvitedBody: "Compartido con {{name}}. Enviamos una invitación a {{email}}; verá el activo cuando la acepte.",
  sharedWithBody: "Compartido con {{name}}. Ya puede ver este activo en AssetWRX.",
emailRequiredTitle: "Se requiere correo electrónico",
emailRequiredBody: "Agregue un correo electrónico a este contacto antes de enviar una invitación.",
inviteFailedTitle: "No se puede enviar la invitación",
selectRelationshipTitle: "Seleccionar relación",
selectRelationshipBody: "Elija al menos un tipo de relación antes de guardar.",
accessSaveFailedTitle: "No se puede guardar el acceso al contacto",
accessUpdateFailedTitle: "No se puede actualizar el acceso",
resendInviteFailed: "No se puede reenviar la invitación.",
inviteSent: "Invitación enviada",
inviteUpdated: "Invitación actualizada",
inviteCreated: "Invitación creada",
inviteEmailSentBody: "Correo electrónico de invitación enviado a {{email}}.",
inviteRefreshedEmailFailedBody: "Invitación actualizada, pero falló la entrega del correo electrónico. Puedes volver a intentar reenviar.",
inviteSavedEmailFailedBody: "Invitación guardada para {{email}}. No se pudo enviar el correo electrónico{{errorSuffix}}.",
inviteErrorSuffix: ": {{error}}",
defaultContactName: "Contacto",
savedTitle: "Guardado",
sharedWithCountBody_one: "Compartido con {{count}} contacto. Envíe invitaciones desde el acceso compartido cuando sea necesario.",
sharedWithCountBody_many: "Compartido con {{count}} contactos. Envíe invitaciones desde el acceso compartido cuando sea necesario.",
sharedWithCountBody_other: "Compartido con {{count}} contactos. Envíe invitaciones desde el acceso compartido cuando sea necesario.",
linkedCountBody_one: "{{count}} contacto vinculado.",
linkedCountBody_many: "{{count}} contactos vinculados.",
linkedCountBody_other: "{{count}} contactos vinculados.",
linkContactFailed: "No se puede vincular el contacto con los tipos de relación seleccionados.",
inviteRequiredTitle: "Invitación necesaria",
inviteRequiredNoEmailBody: "El acceso se guardó, pero este contacto no tiene correo, así que no se le puede avisar. Añade su correo en el contacto y toca Enviar invitación en Acceso compartido.",
inviteRequiredBody: "Se guarda el acceso compartido. Envíe una invitación de contacto ahora para que esta persona pueda vincular su cuenta y ver el activo.",
notNow: "Ahora no",
sendInvite: "Enviar invitación",
inviteSentAcceptedBody: "Se envió una invitación a {{email}}. Una vez aceptada, podrá acceder a este activo compartido.",
inviteCreatedDeliveryFailedBody: "Se creó la invitación para {{email}}, pero falló la entrega del correo electrónico. Puede reenviar desde el acceso compartido.",
inviteFailedFallback: "Se guardó el acceso compartido, pero la invitación falló. Inténtalo de nuevo desde Contactos.",
},
lifecycle: {
  standingA11y: "Estado: {{label}}",
  locationCorrected: "Ubicación corregida.",
  moveRecorded: "Traslado registrado. La ubicación anterior queda en el historial.",
decommissioningTitle: "Puesta fuera de servicio",
decommissioningDetail: "Deja el servicio cuando se verifica la orden de trabajo de seguridad{{jobStatusSuffix}}.",
decommissioningJobStatusSuffix: " — la orden de trabajo está {{status}}",
startCommissioningFailedTitle: "No se pudo iniciar la puesta en servicio",
backInService: "De nuevo en servicio",
returnToServiceFailedTitle: "No se pudo devolver este activo al servicio",
openMakeSafeJob: "Abrir la orden de trabajo de seguridad",
startInspection: "Iniciar la inspección",
openInspection: "Abrir la inspección",
createJobsFromFindings: "Crear órdenes de trabajo a partir de hallazgos",
waiveAndReturn: "Eximir y volver a poner en servicio",
putIntoService: "Poner en servicio",
returnToService: "Volver al servicio",
cancel: "Cancelar",
cancelCommissioningTitle: "¿Cancelar la puesta en servicio?",
cancelCommissioningBody: "El caso se cierra como abandonado. La inspección y cualquier orden de trabajo permanecen como registros.",
keepGoing: "Sigue adelante",
cancelCommissioning: "Cancelar puesta en servicio",
commission: "Poner en servicio",
recommission: "Volver a poner en servicio",
unarchived: "Activo desarchivado",
archived: "Activo archivado",
statusUpdateFailedTitle: "No se puede actualizar el estado del activo",
onlyAdminRestoreTitle: "Solo un administrador puede restaurar un activo retirado definitivamente",
onlyAdminRestoreBody: "Pídale a un administrador del espacio de trabajo que lo restaure.",
restoreFromRetiredTitle: "¿Restaurar el activo retirado definitivamente?",
restoreFromRetiredBody: "El registro se reabre como fuera de servicio. Vuelve a ponerlo en servicio (una inspección y después las órdenes de trabajo que genere) para reactivarlo.",
restore: "Restaurar",
restoredOutOfService: "Restaurado: fuera de servicio hasta que se vuelva a poner en servicio",
restoreFailedTitle: "No se puede restaurar el activo",
moveFailedTitle: "No se pudo mover el activo",
moveFailedBody: "No se pudo guardar el movimiento.",
makeSafeRaised: "Se generó la orden de trabajo de seguridad: el activo deja el servicio cuando se verifica",
outOfService: "Fuera de servicio",
decommissionFailedTitle: "No se pudo poner fuera de servicio este activo",
retired: "Retirado definitivamente",
retireFailedTitle: "No se pudo retirar definitivamente este activo",
returnWaiverTitle: "Regreso al servicio con hallazgos sin resolver",
returnWaiverMessage: "Indique por qué el activo puede volver a ponerse en servicio sin una orden de trabajo según lo que encontró la inspección. Esto va en el certificado.",
returnWaiverPlaceholder: "p. ej., Solo estético; programado para la parada de verano.",
returnToServiceConfirm: "Volver al servicio",
},
errors: {
generic: "Error",
updateFailed: "No se pudo actualizar.",
deleteAssetFailed: "No se pudo eliminar el activo.",
saveDetailsFailed: "No se pudieron guardar los detalles del activo.",
removeAccessFailedTitle: "No se puede eliminar el acceso",
removeAccessBody: "¿Eliminar el acceso al espacio de trabajo compartido para {{name}}? Ya no verán este activo como compartido.",
removeAccessDefaultName: "este contacto",
removeAccessTitle: "Quitar acceso",
remove: "Quitar",
couldNotSaveDetailsTitle: "No se pudieron guardar los detalles del activo",
syncFailed: "Error de sincronización.",
},
deleteAsset: {
cannotDeleteTitle: "No se puede eliminar todavía",
cannotDeleteBody: "Este activo todavía tiene trabajo abierto:\n• {{openInspections}} inspecciones abiertas\n• {{openJobs}} órdenes de trabajo abiertas\n• {{openSchedules}} cronogramas activos\n\nCiérrelos/complételos primero, luego eliminar estará disponible.",
confirmWebTitle: "¿Eliminar activo?\n\nEsto no se puede deshacer.",
confirmTitle: "Eliminar activo",
confirmBody: "¿Seguro? Esta acción no se puede deshacer.",
cancel: "Cancelar",
delete: "Eliminar",
},
cancelledSectionLabel: "Cancelado",
readiness: {
complianceHeadline: "Cumplimiento — {{posture}}",
complianceDefaultAction: "Revisar señales de cumplimiento",
inspectionOverdue: "Inspección atrasada",
inspectionDueOn: "Inspección prevista para el {{date}}",
completeOverdueInspection: "Complete la inspección vencida",
prepareAndComplete: "Preparar y completar a tiempo",
foundationRunInspection: "Realice una inspección para generar las primeras señales de salud.",
foundationLastInspectedAgo: "Última inspección hace {{months}} meses: actualizar",
foundationRecentLast_one: "{{count}} reciente · último {{date}}",
foundationRecentLast_many: "{{count}} recientes · último {{date}}",
foundationRecentLast_other: "{{count}} recientes · último {{date}}",
contactsLabel: "Contactos",
contactsLinked_one: "{{count}} vinculado · toque para administrar",
contactsLinked_many: "{{count}} vinculados · toque para administrar",
contactsLinked_other: "{{count}} vinculados · toque para administrar",
contactsAddRecipient: "Añade un propietario o un destinatario de informes",
documentsLabel: "Documentos",
documentsAttached_one: "{{count}} archivo adjunto",
documentsAttached_other: "{{count}} archivos adjuntos",
documentsUpload: "Sube archivos de cumplimiento y garantía",
relationshipsLabel: "Relaciones",
relationshipsLinkedReach_one: "{{count}} vinculado · alcance {{reach}}",
relationshipsLinkedReach_many: "{{count}} vinculados · alcance {{reach}}",
relationshipsLinkedReach_other: "{{count}} vinculados · alcance {{reach}}",
relationshipsMap: "Mapear los activos de los que depende y los que dependen de él",
evidenceLabel: "Evidencia",
documentsAttached_many: "{{count}} archivos adjuntos",
},
evidenceStatus: {
loadingText: "Cargando evidencia de salud, cumplimiento y riesgos...",
failedText: "No se pudo cargar la evidencia de salud, cumplimiento y riesgo.",
loadingSub: "Las puntuaciones aparecerán solo cuando estén disponibles todos los registros necesarios del activo.",
failedSub: "Tire para actualizar. Las puntuaciones están ocultas hasta que se puedan recuperar los registros que faltan.",
},
conditionAccordionTitle: "Salud, cumplimiento y riesgo (desglose completo)",
conditionAccordionSummary: "Puntuaciones, factores y paneles detallados: despliega cuando necesites la información completa.",
kpi: {
labelHealth: "Salud",
labelRisk: "Riesgo",
labelCompliance: "Cumplimiento",
labelOpenJobs: "Trabajos abiertos",
labelRecent: "Recientes",
labelNextDue: "Próximo vencimiento",
labelDocuments: "Documentos",
labelFiles: "Archivos",
labelQuotes: "Presupuestos",
labelLinkedJobs: "Órdenes de trabajo vinculadas",
},
fab: {
shareAsset: "Compartir activo",
shareAssetTooltip: "Permitir que alguien informe problemas en este activo",
shareAssetTooltipAccessOnly: "Dar acceso a este activo a un contacto",
shareAssetDescription: "Dé acceso a este activo a un contacto o abra la recepción pública por QR, para que los problemas le lleguen sin que quien informa necesite una cuenta.",
reportIssue: "Informar de un problema",
reportIssueTooltip: "Informar un problema en este activo",
reportIssueDescription: "Abra un parte de problema con este activo, la ubicación y la persona que informa ya incluidos.",
inspectNow: "Inspeccionar ahora",
inspectNowTooltip: "Iniciar una inspección de este activo",
inspectNowDescription: "Capture condiciones, lecturas, fotografías y firmas utilizando la lista de verificación activa del activo.",
addJob: "Añadir orden de trabajo",
addJobTooltip: "Generar una orden de trabajo para este activo",
addJobDescription: "Envía mantenimiento, reparación o servicio programado. Rellena automáticamente el activo, el sitio y los hallazgos de la última inspección.",
recordReading: "Registrar lectura",
recordReadingTooltip: "Registre una lectura de medidor para este activo",
recordReadingDescription: "Introduzca el número del contador: millas, horas, ciclos. Los planes de mantenimiento por uso cuentan a partir de la última lectura.",
addMaintenancePlan: "Agregar plan de mantenimiento",
addMaintenancePlanTooltip: "Programar trabajo recurrente",
addMaintenancePlanDescription: "Un servicio, prueba o inspección que se repite: por fecha, por contador o lo que ocurra primero. Genera el trabajo por sí solo cuando toca.",
addDocument: "Añadir documento",
addDocumentTooltip: "Adjunte un documento a este activo",
addDocumentDescription: "Suba manuales, garantías, certificados, planos o registros de cumplimiento. Se etiquetan automáticamente con este activo.",
addKnowledge: "Agregar conocimiento",
addKnowledgeTooltip: "Escriba un artículo de conocimiento para este activo.",
addKnowledgeDescription: "Capture conocimientos, procedimientos o notas como un artículo de conocimientos, que se puede buscar y compartir junto con este activo.",
moveAsset: "Mover activo",
moveAssetTooltip: "Registre que este activo está en algún lugar nuevo",
moveAssetDescription: "Indica POR QUÉ cambió la posición y CUÁNDO, para que en el historial un traslado real se distinga de una corrección.",
relateAsset: "Relacionar activo",
relateAssetTooltip: "Vincula este activo a otro en tu registro",
relateAssetDescription: "Cree relaciones padre-hijo, componente o pares. El riesgo y la actividad se propagan entre los activos vinculados.",
contacts: "Contactos",
createContact: "Crear contacto",
viewContactsTooltip: "Ver contactos vinculados a este activo",
addContactTooltip: "Agregar un contacto asociado con este activo",
contactsLinkedDescription: "Propietarios, operadores, técnicos y partes interesadas vinculadas a este activo.",
addContactDescription: "Registre un propietario, operador, técnico, contratista o parte interesada para este activo.",
addContact: "Añadir contacto",
addContactTooltip2: "Vincular un contacto a este activo",
conditionReport: "Asset 360",
conditionReportTooltip: "Asset 360: un informe redactado para el lector que elija. Usa créditos.",
conditionReportDescription: "Un informe generado que cubre tendencias de condición, fallas recurrentes, costo hasta la fecha, estado de cumplimiento y próximas acciones recomendadas.",
guideMe: "Guíame",
guideMeTooltip: "Guíame a través de una tarea en este activo",
guideMeDescription: "Guía paso a paso: programe verificaciones recurrentes, configure un plan de mantenimiento, registre una lectura, agregue un documento o conocimiento, muévalo y más.",
},
guide: {
proactiveLabel: "Programar controles recurrentes",
proactiveHint: "Una inspección que se repite, por lo que se detecta el desgaste antes de que falle.",
maintenancePlanLabel: "Configurar un plan de mantenimiento",
maintenancePlanHint: "Trabajo que se repite por fecha, por contador o lo que ocurra primero.",
meterReadingLabel: "Registrar una lectura del contador",
meterReadingHint: "Millas, horas o ciclos, para que los planes que cuentan por uso se cumplan a tiempo.",
raiseRequestLabel: "Informar un problema",
raiseRequestHint: "Registre un problema y elija lo que debería suceder a continuación.",
addDocumentLabel: "Añadir un documento",
addDocumentHint: "Certificados, garantías y manuales, con recordatorios de caducidad.",
knowledgeLabel: "Añadir conocimiento",
knowledgeHint: "Instrucciones, preguntas frecuentes o notas que su equipo podrá encontrar más adelante.",
moveLabel: "Registrar un traslado",
moveHint: "Dónde está ahora y si se movió o se registró mal.",
teamLabel: "Moverlo a un equipo",
teamHint: "Para que todos los miembros del equipo puedan trabajar en ello.",
relateLabel: "Vincular un activo relacionado",
relateHint: "Un activo superior, una pieza o algo de lo que depende.",
publicIntakeLabel: "Permitir que cualquiera informe por QR",
publicIntakeHint: "Entrada pública: informe un problema escaneando un código, sin iniciar sesión.",
aiReportLabel: "Preparar un informe Asset 360",
aiReportHint: "La IA lo redacta con todo lo que se sabe de este activo, para el lector que elija. Los créditos se usan solo cuando está redactado.",
decommissionLabel: "Sacarlo de servicio",
decommissionHint: "Póngalo fuera de servicio con un motivo y, si hace falta, una orden de trabajo de puesta en seguridad.",
commissionLabelPlanned: "Ponlo en servicio",
commissionLabelOther: "Vuelva a ponerlo en servicio.",
commissionHint: "Una inspección de puesta en servicio, órdenes de trabajo a partir de lo que encuentra y luego nuevamente en servicio.",
retireLabel: "Retirarlo definitivamente",
retireHint: "Cerrar el registro definitivamente, dejando constancia de cómo se dio de baja.",
},
copilot: {
openRequests: "Solicitudes abiertas",
openInspections: "Inspecciones abiertas",
openJobs: "Trabajos abiertos",
reviewOpenWork: "Revisar el trabajo abierto",
reviewAsset: "Revisar activo",
suggestNextSteps: "Sugerir próximos pasos",
automateRenewalWork: "Automatizar el trabajo de renovación",
},
overflow: {
archive: "Archivar",
unarchive: "Desarchivar",
changeStatus: "Cambiar estado",
decommission: "Poner fuera de servicio",
restoreFromRetired: "Restaurar desde retirado definitivamente",
retireAsset: "Retirar definitivamente el activo",
delete: "Eliminar",
deleteHelpText: "La eliminación está disponible solo después de que se cierren o completen todas las inspecciones, órdenes de trabajo y cronogramas.",
},
refineWork: {
title: "Refinar trabajo",
status: "Estado",
all: "Todos",
scheduled: "Programado",
active: "Activa",
completed: "Completado",
},
sections: {
esg: "ESG",
overview: "Resumen",
details: "Detalles",
maintenance: "Mantenimiento",
work: "Trabajo",
reports: "Informes",
documents: "Documentos",
relationships: "Relaciones",
knowledge: "Conocimiento",
activity: "Actividad",
health: "Salud",
particulars: "Características",
contacts: "Contactos",
linkedAssets: "Activos vinculados",
labelWithCount: "{{label}}, {{count}}",
articles: "Artículos",
},
},
  advancedReport: {
    shareFailedTitle: "No se pudo guardar el informe",
    shareGenerated: "Redactado por IA el {{date}}. Revíselo antes de confiar en él.",
    shareTitle: "Informe del activo: {{name}}",
    pdfDocType: "Informe del activo",
    insightTitle: "Resumen del informe del activo",
    heroSub: "La IA redacta un informe con las inspecciones, trabajos, documentos, riesgos e historial de mantenimiento de este activo.",
    heroTitle: "Informe del activo",
    fallbackTitle: "Informe del activo",
    metaKind: "Informe con IA",
    summaryPlaceholder: "Toque Generar informe para ver el riesgo, el estado, el cumplimiento de este activo y qué hacer después.",
    actionGenerate: "Genere el informe del activo.",
    generateFailedTitle: "No se generó el informe del activo",
    analysisHistory: "Historial",
    sourceGenerated: "Redactado por IA",
    sourceSetup: "Aún no generado",
  },
  createForm: {
    checkout: {
      syncingBody: "El pago se completó. Espera un momento y vuelve a tocar Crear activo.",
      syncingTitle: "Tu plan está casi listo",
      cancelledBody: "Los datos de tu activo siguen aquí. Toca Crear activo cuando estés listo.",
      notStartedTitle: "Plan no iniciado",
      cancelledTitle: "Pago cancelado",
      openFailedBody: "Comprueba tu conexión e inténtalo de nuevo.",
      openFailedTitle: "No se pudo abrir el pago",
    },
    save: {
      saveWithoutPhotos: "Crear sin fotos",
      cancel: "Cancelar",
      photoUploadFailedBody: "¿Crear el activo sin fotos? Puedes añadirlas más tarde con Editar.",
      photoUploadFailedTitle: "No se pudieron subir las fotos",
      photosFailedBody: "No se pudieron subir las fotos. Abre el activo y toca Editar para añadirlas.",
      photosFailedTitle: "Activo creado sin fotos",
      duplicateDecisionBody: "No se guardó tu elección sobre el posible duplicado. Puedes vincularlos más tarde desde el activo.",
      duplicateDecisionTitle: "Activo creado",
      partialRelBody: "Vínculos con otros activos sin guardar: {{n}}. Añádelos desde la sección Relaciones del activo.",
      partialRelTitle: "Activo creado, algunos vínculos no se guardaron",
      qrNotLinkedBody: "Abre el activo y vincula la etiqueta desde su sección QR.",
      qrNotLinkedTitle: "Activo creado, etiqueta QR no vinculada",
      failedBody: "Comprueba tu conexión y vuelve a tocar Crear activo. Tus datos siguen aquí.",
      failedTitle: "No se pudo crear el activo",
      nameRequiredBody: "Ponle nombre al activo y toca Crear activo.",
      nameRequiredTitle: "Escribe un nombre",
      signInBody: "Vuelve a iniciar sesión y toca Crear activo.",
      signInTitle: "Vuelve a iniciar sesión",
    },
    duplicates: {
      failedBody: "Comprueba tu conexión e inténtalo de nuevo.",
      failedTitle: "No se pudieron buscar duplicados",
      foundTitle: "Podría ser el mismo activo",
      noneBody: "Nada más coincide con este nombre o ID.",
      noneTitle: "No se encontraron duplicados",
      needNameBody: "Escribe el nombre del activo y luego busca duplicados.",
      needNameTitle: "Escribe primero un nombre",
    },
    idHint: "El número de su placa o etiqueta. Permite encontrar el activo escaneándolo.",
    useIdFromPhoto: "Usar «{{id}}» como ID o número de serie",
    readPlateTitle: "Leer la placa",
    externalIdOptional: "{{label}} (opcional)",
    unnamed: "Activo sin nombre",
    dictation: {
      listening: "Escuchando…",
      heard: "Escuchado: {{text}}",
      finishing: "Terminando…",
      inserting: "Añadiendo lo que dijiste…",
      stopA11y: "Dejar de dictar",
      dictateA11y: "Dictar el nombre",
      stop: "Detener",
      dictate: "Dictar",
    },
    footer: {
      creating: "Creando…",
      create: "Crear activo",
      needName: "Escribe un nombre para empezar",
      needsPlan: "El siguiente activo necesita un plan de pago",
      needsPlanHint: "Lo que has introducido se conserva mientras eliges.",
      ready: "Listo para crear",
    },
    sectionWhy: {
      details: "Añade la marca, el modelo y su importancia. Puedes hacerlo más tarde.",
      identify: "Añade una foto y el número de serie o código de barras para escanearlo en el lugar.",
      location: "Añade el sitio o la dirección para que se pueda encontrar.",
      basics: "Ponle nombre y elige un tipo. Es todo lo que necesitas para crearlo.",
    },
    location: {
      locationOptional: "Ubicación (opcional)",
      propertyAddress: "Dirección del inmueble",
      siteSelected: "Sitio · {{name}}",
      siteLabel: "Sitio",
      noSiteBody: "No hay ningún sitio cerca de ti. Elige uno de la lista o déjalo vacío.",
      noSiteTitle: "No hay ningún sitio cerca",
      noAddressBody: "Encontramos tu ubicación, pero no la dirección. Escríbela tú.",
      noAddressTitle: "No se encontró la dirección",
    },
    photos: {
      summaryCount: "{{used}} de {{max}}",
      countFull: "{{max}} de {{max}}. Es el máximo.",
      countMore: "{{used}} de {{max}}. Puedes añadir {{left}} más.",
      galleryA11y: "Elegir de tus fotos. {{used}} de {{max}} usadas.",
      cameraA11y: "Hacer una foto. {{used}} de {{max}} usadas.",
      mainFullA11y: "Foto principal. {{max}} de {{max}} fotos añadidas.",
      mainA11y: "Foto principal. {{used}} de {{max}} añadidas. Toca para añadir otra.",
      addA11y: "Añadir fotos, hasta {{max}}",
      cameraBody: "Permite que AssetWRX use la cámara en los ajustes del teléfono y vuelve a intentarlo.",
      libraryBody: "Permite que AssetWRX use tus fotos en los ajustes del teléfono y vuelve a intentarlo.",
      permissionTitle: "Permitir acceso",
      limitBody: "Puedes añadir hasta {{max}} fotos.",
      limitTitle: "Límite de fotos alcanzado",
    },
    suggestion: {
      useA11y: "Usar {{label}} como tipo",
      dismiss: "No, gracias",
      use: "Usar este",
      fromPhoto: "Según la foto, parece: {{label}}",
      looksLike: "Parece: {{label}}",
    },
    photoIdentify: {
      noMatchBody: "No pudimos saber qué es por la foto. Prueba con una foto más clara o elige el tipo tú mismo.",
      noMatchTitle: "No se encontró coincidencia",
      noCreditsBody: "Tu espacio de trabajo no tiene créditos de IA. Elige el tipo tú mismo.",
      failedBody: "Inténtalo de nuevo o elige el tipo tú mismo.",
      failedTitle: "No se pudo leer la foto",
      a11y: "Detectar el tipo de activo con la foto",
      busy: "Analizando la foto…",
      button: "Detectar el tipo con la foto",
    },
    leaveGuard: {
      keep: "Seguir editando",
      leave: "Salir",
      message: "Tu nuevo activo aún no se ha guardado. ¿Salir y perderlo?",
    },
    namePlaceholder: {
      other: "Por ejemplo: Iluminación del escenario",
      equipment: "Por ejemplo: Caldera 3",
      property: "p. ej., Calle del Roble 14",
      car: "Por ejemplo: Toyota Camry 2024",
    },
    typeDesc: {
      other: "Todo lo demás",
      equipment: "Máquinas y herramientas",
      property: "Edificios y terrenos",
      car: "Vehículos y flotas",
    },
  },
  lifecycleBanner: {
    plannedBody: "Toca Poner en servicio: primero una inspección y luego los trabajos que detecte.",
    decommissionedBody: "Sus programaciones están en pausa. Toca Volver a poner en servicio para recuperarlo.",
    archivedBody: "Puedes verlo y editarlo. Para añadir inspecciones o trabajos, desarchívalo desde el menú ⋯.",
    retiredBody: "Su historial sigue disponible, pero ya no admite inspecciones ni trabajos nuevos.",
    since: "Desde el {{date}}",
  },
  shareReview: {
    rights: {
      view: "Puede ver este activo",
      viewBody: "Lo ve en su propia cuenta.",
      workBody: "Informa de problemas y los sigue hasta que se resuelven.",
      jobs: "Ver trabajos",
      jobsBody: "Los trabajos de este activo y cómo van.",
      inspections: "Ver inspecciones",
      inspectionsBody: "Los resultados de inspección de este activo.",
      documents: "Abrir documentos",
      documentsBody: "Los documentos son privados hasta que actives esto.",
    },
    confirmLink: "Vincular contacto",
    confirmShare: "Compartir",
    selectContact: "Elige primero un contacto",
    batchHint: "Contactos seleccionados: {{n}}. El acceso de abajo se aplica a todos.",
  },
  editForm: {
    photoCountNone: "0 de {{max}} fotos. Todas opcionales.",
    photosHintA11y: "Opcional. Hasta {{max}} fotos.",
    saveFailedBody: "Comprueba tu conexión y vuelve a tocar Guardar. Tus cambios siguen aquí.",
    saveFailedTitle: "No se pudieron guardar los cambios",
    saved: "Cambios guardados.",
    partialRelTitle: "Cambios guardados, algunos vínculos no se guardaron",
    uploadFailedBody: "Comprueba tu conexión y vuelve a tocar Guardar. Tus cambios siguen aquí.",
    signInBody: "Vuelve a iniciar sesión y toca Guardar.",
    nameRequiredBody: "Ponle nombre al activo y toca Guardar.",
    linkFailedTitle: "No se pudo marcar el duplicado",
    linkedBody: "Ambos activos muestran ahora el vínculo para revisarlos más tarde.",
    linkedTitle: "Marcado como posible duplicado",
    openExisting: "Abrir el otro activo",
    improve: "Mejorar con IA",
    improving: "Mejorando…",
    improveRationale: "Lee las notas nuevas y toca Usar para conservarlas.",
    improveFailedBody: "Inténtalo de nuevo o conserva tu texto.",
    improveFailedTitle: "No se pudo mejorar la descripción",
    improveNeedsDraftBody: "Escribe o dicta una descripción breve y toca Mejorar con IA.",
    improveNeedsDraftTitle: "Escribe primero unas palabras",
    improvedTitle: "Notas del activo mejoradas",
    notFound: "No se encontró este activo. Puede que se haya eliminado o que no tengas acceso.",
    loadFailed: "No se pudo cargar este activo. Comprueba tu conexión y toca Reintentar.",
  },
  sharedView: {
    facts: {
      nextVisit: "Próxima visita: {{date}}",
      jobs: "Trabajos: {{n}}",
    },
    requests: {
      title: "Tus solicitudes",
      you: "Tú: {{text}}",
      photo: "Foto",
      unread: "Respuesta nueva",
    },
    thread: {
      title: "Solicitud",
      loading: "Abriendo la solicitud…",
      loadFailedTitle: "No se pudo abrir esta solicitud",
      loadFailed: "Comprueba tu conexión y toca Reintentar.",
      showProgress: "Mostrar el progreso y lo que puedes hacer",
      hideProgress: "Ocultar el progreso",
    },
    records: {
      documents: "Documentos",
      jobs: "Trabajos",
      inspections: "Inspecciones",
      no_documents: "Este activo aún no tiene documentos.",
      no_jobs: "Este activo aún no tiene trabajos.",
      no_inspections: "Este activo aún no tiene inspecciones.",
      loadFailed: "No se ha podido cargar. Desliza hacia abajo para reintentar.",
      openDocument: "Abrir {{title}}",
      expires: "Caduca el {{date}}",
      due: "Vence el {{date}}",
      done: "Hecho el {{date}}",
      inspection: "Inspección",
      inspectionNumbered: "Inspección {{number}}",
      issues: "Incidencias: {{n}}",
    },
    raiseRequest: "Informar de un problema",
    sharedWithYou: "Compartido contigo",
    kpiRelatedJobs: "Trabajos relacionados",
    none: "Ninguna",
    kpiNextInspection: "Próxima inspección",
    kpiStatus: "Estado",
    permDocuments: "Documentos",
    permInspections: "Inspecciones",
    permJobs: "Trabajos",
    accept: "Aceptar",
    working: "Procesando…",
    invitation: "Invitación",
    thisAsset: "Este activo",
    tryAgain: "Reintentar",
    checking: "Comprobando…",
    sharedReadOnly: "Compartido · solo lectura",
    readOnly: "Solo lectura",
    refreshFailedBody: "Comprueba tu conexión y toca Reintentar.",
    refreshFailedTitle: "No se pudo actualizar",
    stillNoAccessBody: "Tu cuenta aún no está vinculada a este elemento compartido. Acepta la invitación de tu correo o pide a quien lo compartió que lo vuelva a compartir con tu correo.",
    stillNoAccessTitle: "Sigues sin acceso",
    sharedAccess: "Compartido contigo",
    pendingAccess: "Pendiente de que aceptes",
    job: "Orden de trabajo",
    linkedAsset: "Activo vinculado",
    theirWorkspace: "su espacio de trabajo",
    aTeamMember: "Un miembro del equipo",
    checkFailed: "No pudimos comprobar tu acceso a este activo. Comprueba tu conexión y toca Reintentar.",
    notScheduled: "Sin programar",
    accessTimedOut: "La comprobación de tu acceso tardó demasiado. Comprueba tu conexión y toca Reintentar.",
  },
retireConfirmWord: "RETIRAR",
knowledgeKind: {
  updatedAgo: "actualizado {{when}}",
  someone: "Un miembro del equipo",
  pinnedPrefix: "Fijado",
  link: "Enlace externo",
  howto: "Instrucciones",
  note: "Nota",
  faq: "Preguntas frecuentes",
  file: "Archivo",
},
knowledgeTab: {
  searchPlaceholder: "Buscar en el conocimiento…",
  uploadDocument: "Subir documento",
  noMatchingArticles: "No hay artículos que coincidan",
  noArticlesYet: "Aún no hay artículos",
  noMatchHint: "Ningún artículo coincide con la búsqueda o los filtros actuales.",
  emptyManageHint: "Añade guías, enlaces, preguntas frecuentes o archivos para que tu equipo los encuentre en el trabajo.",
  emptyReadHint: "Nada coincide con tu búsqueda o aún no se ha publicado nada.",
  loadErrorWithReason: "{{error}}. Comprueba tu conexión e inténtalo de nuevo.",
  loadErrorHint: "Comprueba tu conexión e inténtalo de nuevo.",
  newArticle: "Nuevo artículo",
  editArticle: "Editar artículo",
  exactMatch: "Coincidencia exacta",
  anyMatchCommaSeparated: "Cualquier coincidencia, separadas por comas",
  commaSeparated: "Separadas por comas",
  polishedDescription: "Descripción mejorada",
  polishedContent: "Contenido mejorado",
  polishFailedTitle: "No se pudo mejorar",
  polishUnavailable: "No se puede mejorar ahora mismo.",
  polishReview: "Revisa el texto mejorado antes de aplicarlo.",
  polishDescriptionFailed: "No se pudo mejorar la descripción.",
  polishContentFailed: "No se pudo mejorar el contenido.",
  titleRequiredTitle: "Título obligatorio",
  titleRequiredBody: "Introduce un título.",
  errorTitle: "Error",
  saveFailed: "No se pudo guardar",
  uploadFailedTitle: "Error al subir",
  uploadFailedBody: "No se pudo subir el archivo",
  deleteTitle: "Eliminar artículo",
  deleteBody: "¿Quitar «{{title}}»?",
  deleteFailed: "No se pudo eliminar",
  cancel: "Cancelar",
  delete: "Eliminar",
},
needsAttention: {
  requestsAwaitingApproval_one: "{{count}} solicitud pendiente de aprobación",
  requestsAwaitingApproval_many: "{{count}} solicitudes pendientes de aprobación",
  requestsAwaitingApproval_other: "{{count}} solicitudes pendientes de aprobación",
  requestsAwaitingWork_one: "{{count}} solicitud aprobada necesita trabajo",
  requestsAwaitingWork_many: "{{count}} solicitudes aprobadas necesitan trabajo",
  requestsAwaitingWork_other: "{{count}} solicitudes aprobadas necesitan trabajo",
  overdueJobs_one: "{{count}} trabajo vencido",
  overdueJobs_many: "{{count}} trabajos vencidos",
  overdueJobs_other: "{{count}} trabajos vencidos",
  inspectionsAwaitingApproval_one: "{{count}} inspección pendiente de aprobación",
  inspectionsAwaitingApproval_many: "{{count}} inspecciones pendientes de aprobación",
  inspectionsAwaitingApproval_other: "{{count}} inspecciones pendientes de aprobación",
  expiredDocuments_one: "{{count}} documento caducado",
  expiredDocuments_many: "{{count}} documentos caducados",
  expiredDocuments_other: "{{count}} documentos caducados",
  expiringSoonDocuments_one: "{{count}} documento caduca pronto",
  expiringSoonDocuments_many: "{{count}} documentos caducan pronto",
  expiringSoonDocuments_other: "{{count}} documentos caducan pronto",
  overdueSchedules_one: "{{count}} inspección programada vencida",
  overdueSchedules_many: "{{count}} inspecciones programadas vencidas",
  overdueSchedules_other: "{{count}} inspecciones programadas vencidas",
  unresolvedFindings_one: "{{count}} hallazgo de inspección sin resolver",
  unresolvedFindings_many: "{{count}} hallazgos de inspección sin resolver",
  unresolvedFindings_other: "{{count}} hallazgos de inspección sin resolver",
  pendingApprovals_one: "{{count}} informe compartido pendiente de visto bueno",
  pendingApprovals_many: "{{count}} informes compartidos pendientes de visto bueno",
  pendingApprovals_other: "{{count}} informes compartidos pendientes de visto bueno",
  openHighUrgencyJobs_one: "{{count}} trabajo abierto de urgencia alta",
  openHighUrgencyJobs_many: "{{count}} trabajos abiertos de urgencia alta",
  openHighUrgencyJobs_other: "{{count}} trabajos abiertos de urgencia alta",
  failedInspections_one: "La inspección reciente detectó fallos",
  failedInspections_many: "{{count}} inspecciones con fallos",
  failedInspections_other: "{{count}} inspecciones con fallos",
  detail: {
    approveOrDecline: "Aprobar o rechazar",
    createJobOrInspection: "Crear un trabajo o una inspección",
    progressOrReschedule: "Avanzar o reprogramar el trabajo",
    reviewAndApprove: "Revisar y aprobar",
    renewOrReplace: "Renovar o sustituir archivos",
    planRenewal: "Planificar la renovación",
  },
},
conditionTrend: {
  loading: "Cargando inspecciones completadas y valoraciones de estado…",
  loadFailed: "No se pudieron cargar las inspecciones completadas ni las valoraciones de estado. Desliza para actualizar e inténtalo de nuevo.",
  emptyNoInspections: "La tendencia del estado aparece tras la primera inspección valorada.",
  emptyUnrated_one: "{{count}} inspección completada no tiene valoración de estado de 1 a 5, así que aún no hay tendencia.",
  emptyUnrated_many: "{{count}} inspecciones completadas no tienen valoración de estado de 1 a 5, así que aún no hay tendencia.",
  emptyUnrated_other: "{{count}} inspecciones completadas no tienen valoración de estado de 1 a 5, así que aún no hay tendencia.",
  band: { good: "Bueno", fair: "Aceptable", poor: "Deficiente" },
  latest: "{{percent}} % · {{band}}",
  readingsA11y: "Lecturas de estado, de la más antigua a la más reciente: {{readings}}",
  readingA11y: "{{percent}} por ciento {{band}}",
  ratedInspections_one: "{{count}} inspección valorada",
  ratedInspections_many: "{{count}} inspecciones valoradas",
  ratedInspections_other: "{{count}} inspecciones valoradas",
  oneRated: "Una inspección valorada · una más muestra la tendencia",
  down_one: "Baja del {{first}} % al {{last}} % en {{count}} inspección.",
  down_many: "Baja del {{first}} % al {{last}} % en {{count}} inspecciones.",
  down_other: "Baja del {{first}} % al {{last}} % en {{count}} inspecciones.",
  steady_one: "Estable en el {{last}} % en {{count}} inspección.",
  steady_many: "Estable en el {{last}} % en {{count}} inspecciones.",
  steady_other: "Estable en el {{last}} % en {{count}} inspecciones.",
  up_one: "Sube del {{first}} % al {{last}} % en {{count}} inspección.",
  up_many: "Sube del {{first}} % al {{last}} % en {{count}} inspecciones.",
  up_other: "Sube del {{first}} % al {{last}} % en {{count}} inspecciones.",
},
intelligenceCard: {
  state: {
    stable: "Estable",
    watch: "Vigilar",
    deteriorating: "Empeorando",
    action_recommended: "Acción recomendada",
    critical: "Crítico",
  },
  strength: {
    early_signal: "Señal temprana",
    moderate_evidence: "Pruebas moderadas",
    strong_evidence: "Pruebas sólidas",
  },
  conditionScore: "Estado {{score}}/100 · {{strength}}",
  dataQuality: "Calidad de los datos: {{warning}}",
  suggestedBy: "Sugerido antes del {{date}}",
  recommendation: {
    inspect_sooner: "Inspeccionar antes del mantenimiento previsto",
    maintenance_sooner: "Adelantar el mantenimiento previsto",
    review_interval: "Revisar el intervalo de mantenimiento",
    raise_follow_up: "Crear trabajo de seguimiento",
    monitor: "Registrar una lectura del contador para que el plan sea fiable",
  },
  recordFailedTitle: "No se pudo registrar",
  dismissFailedTitle: "No se pudo descartar",
  stillOpenBody: "La recomendación sigue abierta. Inténtalo de nuevo.",
},
documentSubtype: {
  label: {
    gas_safety: "Seguridad del gas",
    electrical: "Electricidad",
    fire_safety: "Protección contra incendios",
    pat_testing: "Prueba de aparatos portátiles (PAT)",
    lift: "Ascensor (LOLER)",
    legionella: "Legionela",
    pressure_system: "Sistema a presión",
    ppe: "EPI",
    vehicle_roadworthy: "Aptitud para circular (MOT)",
    epc: "Certificado energético (EPC)",
    manufacturer: "Fabricante",
    extended: "Ampliada",
    service_contract: "Contrato de servicio",
    regulatory: "Normativo",
    audit: "Auditoría",
    insurance: "Seguro",
    manual: "Manual de uso",
    drawing: "Plano",
    photo: "Foto",
    report: "Informe",
  },
  titleExample: {
    gas_safety: "p. ej. Certificado de seguridad del gas",
    electrical: "p. ej. Certificado de instalación eléctrica",
    fire_safety: "p. ej. Evaluación del riesgo de incendio",
    pat_testing: "p. ej. Registro de prueba de aparatos portátiles",
    lift: "p. ej. Examen exhaustivo LOLER",
    legionella: "p. ej. Evaluación del riesgo de legionela",
    pressure_system: "p. ej. Plan de examen por escrito",
    ppe: "p. ej. Registro de inspección de EPI",
    vehicle_roadworthy: "p. ej. Certificado MOT",
    epc: "p. ej. Certificado de eficiencia energética",
    manufacturer: "p. ej. Garantía del fabricante",
    extended: "p. ej. Garantía ampliada",
    service_contract: "p. ej. Contrato de servicio anual",
    regulatory: "p. ej. Aviso de cumplimiento normativo",
    audit: "p. ej. Informe de auditoría de cumplimiento",
    insurance: "p. ej. Seguro de responsabilidad civil",
    manual: "p. ej. Manual de funcionamiento",
    drawing: "p. ej. Plano de planta",
    photo: "p. ej. Foto del estado del activo",
    report: "p. ej. Informe de inspección del estado",
  },
  titleExampleByType: {
    certificate: "p. ej. Certificado de seguridad del gas",
    warranty: "p. ej. Garantía del fabricante",
    compliance: "p. ej. Póliza de seguro",
    general: "p. ej. Manual del equipo",
  },
},
retirePreflight: {
  openInspections_many: "{{count}} inspecciones en curso: complétalas o descártalas primero",
  openJobs_many: "{{count}} trabajos abiertos: complétalos o cancélalos primero",
  openCase: "Hay un alta o baja en curso: termínala o cancélala primero",
  openInspections_other: "{{count}} inspecciones en curso: complétalas o descártalas primero",
  openInspections_one: "1 inspección en curso: complétala o descártala primero",
  openJobs_other: "{{count}} trabajos abiertos: complétalos o cancélalos primero",
  openJobs_one: "1 trabajo abierto: complétalo o cancélalo primero",
},
readinessCard: {
needAttention_one: "{{count}} necesita atención",
needAttention_many: "{{count}} necesitan atención",
needAttention_other: "{{count}} necesitan atención",
foundationsInPlace: "Bases establecidas",
},
documentTakeOver: {
title: "¿Validar en su lugar?",
body_one: "{{name}} no ha validado \"{{title}}\" desde hace {{count}} día. ¿Validarlo como equipo del activo? Se registrará como hecho en su nombre.",
body_many: "{{name}} no ha validado \"{{title}}\" desde hace {{count}} de días. ¿Validarlo como equipo del activo? Se registrará como hecho en su nombre.",
body_other: "{{name}} no ha validado \"{{title}}\" desde hace {{count}} días. ¿Validarlo como equipo del activo? Se registrará como hecho en su nombre.",
keepWaiting: "Seguir esperando",
validate: "Validar",
note_one: "Validado por el equipo del activo en lugar de {{name}} tras {{count}} día sin respuesta.",
note_many: "Validado por el equipo del activo en lugar de {{name}} tras {{count}} de días sin respuesta.",
note_other: "Validado por el equipo del activo en lugar de {{name}} tras {{count}} días sin respuesta.",
},
lifecycleCopy: {
inspectionDone: "Inspección ✓",
inspectionInProgress: "Inspección en curso",
inspectionNotStarted: "Inspección sin empezar",
jobsVerified: "Órdenes de trabajo verificadas: {{verified}}/{{raised}}",
findingsWaived_one: "{{count}} hallazgo dispensado",
findingsWaived_many: "{{count}} de hallazgos dispensados",
findingsWaived_other: "{{count}} hallazgos dispensados",
findingsNeedJob_one: "{{count}} hallazgo necesita una orden de trabajo",
findingsNeedJob_many: "{{count}} de hallazgos necesitan una orden de trabajo",
findingsNeedJob_other: "{{count}} hallazgos necesitan una orden de trabajo",
noFindings: "Sin hallazgos",
retireNoNewWork: "Nunca más admitirá inspecciones ni órdenes de trabajo nuevas. El historial y los documentos se pueden seguir consultando.",
retireSharesRevoked_one: "{{count}} acceso compartido revocado",
retireSharesRevoked_many: "{{count}} de accesos compartidos revocados",
retireSharesRevoked_other: "{{count}} accesos compartidos revocados",
retireIntakeOff: "Enlace de recepción pública desactivado",
retireSchedulesCancelled_one: "{{count}} inspección programada cancelada",
retireSchedulesCancelled_many: "{{count}} de inspecciones programadas canceladas",
retireSchedulesCancelled_other: "{{count}} inspecciones programadas canceladas",
retireNoLongerBilled: "Ya no se factura",
retireHidden: "Oculto en listas, KPI y riesgo; aparece en Retirados definitivamente",
},
complianceSummary: {
recentInspections_one: "{{count}} inspección completada en los últimos 30 días",
recentInspections_many: "{{count}} de inspecciones completadas en los últimos 30 días",
recentInspections_other: "{{count}} inspecciones completadas en los últimos 30 días",
documentsValid: "Todos los documentos de cumplimiento con seguimiento están vigentes",
noOverdueSchedules: "No hay inspecciones programadas vencidas",
noOpenJobs: "No hay órdenes de trabajo abiertas vinculadas a este activo",
uploadDocuments: "Suba documentos de cumplimiento (certificados, garantías o pruebas) para este activo",
renewExpired_one: "Renueve {{count}} documento de cumplimiento caducado",
renewExpired_many: "Renueve {{count}} de documentos de cumplimiento caducados",
renewExpired_other: "Renueve {{count}} documentos de cumplimiento caducados",
planRenewals_one: "Planifique la renovación de {{count}} documento que caduca pronto",
planRenewals_many: "Planifique la renovación de {{count}} de documentos que caducan pronto",
planRenewals_other: "Planifique la renovación de {{count}} documentos que caducan pronto",
establishBaseline: "Complete una inspección para establecer una base de cumplimiento verificable",
scheduleNewInspection_one: "Programe una nueva inspección — la última inspección completada fue hace {{count}} día",
scheduleNewInspection_many: "Programe una nueva inspección — la última inspección completada fue hace {{count}} de días",
scheduleNewInspection_other: "Programe una nueva inspección — la última inspección completada fue hace {{count}} días",
completeOverdueSchedules_one: "Complete {{count}} inspección programada vencida",
completeOverdueSchedules_many: "Complete {{count}} de inspecciones programadas vencidas",
completeOverdueSchedules_other: "Complete {{count}} inspecciones programadas vencidas",
resolveOverdueJobs_one: "Resuelva o reprograme {{count}} orden de trabajo abierta vencida",
resolveOverdueJobs_many: "Resuelva o reprograme {{count}} de órdenes de trabajo abiertas vencidas",
resolveOverdueJobs_other: "Resuelva o reprograme {{count}} órdenes de trabajo abiertas vencidas",
reviewUrgentJobs_one: "Revise {{count}} orden de trabajo abierta de alta urgencia y actualice su estado o su fecha de vencimiento",
reviewUrgentJobs_many: "Revise {{count}} de órdenes de trabajo abiertas de alta urgencia y actualice su estado o sus fechas de vencimiento",
reviewUrgentJobs_other: "Revise {{count}} órdenes de trabajo abiertas de alta urgencia y actualice su estado o sus fechas de vencimiento",
addressFindings_one: "Resuelva {{count}} hallazgo pendiente de la última inspección completada",
addressFindings_many: "Resuelva {{count}} de hallazgos pendientes de la última inspección completada",
addressFindings_other: "Resuelva {{count}} hallazgos pendientes de la última inspección completada",
followUpApprovals_one: "Haga el seguimiento de {{count}} aprobación pendiente",
followUpApprovals_many: "Haga el seguimiento de {{count}} de aprobaciones pendientes",
followUpApprovals_other: "Haga el seguimiento de {{count}} aprobaciones pendientes",
},
conditionImpacts: {
expiredDocumentsLabel_one: "Documento de cumplimiento caducado",
expiredDocumentsLabel_many: "Documentos de cumplimiento caducados",
expiredDocumentsLabel_other: "Documentos de cumplimiento caducados",
expiredDocumentsInline_one: "un documento de cumplimiento caducado",
expiredDocumentsInline_many: "documentos de cumplimiento caducados",
expiredDocumentsInline_other: "documentos de cumplimiento caducados",
expiredDocumentsRationale_one: "{{count}} documento ha superado su fecha de caducidad. Cada elemento caducado resta hasta 25 puntos a la puntuación (50 como máximo en total).",
expiredDocumentsRationale_many: "{{count}} de documentos han superado su fecha de caducidad. Cada elemento caducado resta hasta 25 puntos a la puntuación (50 como máximo en total).",
expiredDocumentsRationale_other: "{{count}} documentos han superado su fecha de caducidad. Cada elemento caducado resta hasta 25 puntos a la puntuación (50 como máximo en total).",
expiringDocumentsLabel_one: "Documento que caduca pronto",
expiringDocumentsLabel_many: "Documentos que caducan pronto",
expiringDocumentsLabel_other: "Documentos que caducan pronto",
expiringDocumentsInline_one: "un documento que caduca pronto",
expiringDocumentsInline_many: "documentos que caducan pronto",
expiringDocumentsInline_other: "documentos que caducan pronto",
expiringDocumentsRationale_one: "{{count}} documento está dentro del plazo de aviso de renovación antes de caducar (hasta 8 puntos cada uno, máximo 24).",
expiringDocumentsRationale_many: "{{count}} de documentos están dentro del plazo de aviso de renovación antes de caducar (hasta 8 puntos cada uno, máximo 24).",
expiringDocumentsRationale_other: "{{count}} documentos están dentro del plazo de aviso de renovación antes de caducar (hasta 8 puntos cada uno, máximo 24).",
overdueSchedulesLabel_one: "Inspección programada vencida",
overdueSchedulesLabel_many: "Inspecciones programadas vencidas",
overdueSchedulesLabel_other: "Inspecciones programadas vencidas",
overdueSchedulesInline_one: "una inspección programada vencida",
overdueSchedulesInline_many: "inspecciones programadas vencidas",
overdueSchedulesInline_other: "inspecciones programadas vencidas",
overdueSchedulesRationale_one: "{{count}} inspección programada está marcada como vencida (12 puntos cada una, máximo 24).",
overdueSchedulesRationale_many: "{{count}} de inspecciones programadas están marcadas como vencidas (12 puntos cada una, máximo 24).",
overdueSchedulesRationale_other: "{{count}} inspecciones programadas están marcadas como vencidas (12 puntos cada una, máximo 24).",
overdueOpenJobsLabel_one: "Orden de trabajo abierta vencida",
overdueOpenJobsLabel_many: "Órdenes de trabajo abiertas vencidas",
overdueOpenJobsLabel_other: "Órdenes de trabajo abiertas vencidas",
overdueOpenJobsInline_one: "una orden de trabajo abierta vencida",
overdueOpenJobsInline_many: "órdenes de trabajo abiertas vencidas",
overdueOpenJobsInline_other: "órdenes de trabajo abiertas vencidas",
overdueOpenJobsRationale_one: "{{count}} orden de trabajo abierta tiene una fecha de vencimiento ya pasada (10 puntos cada una, máximo 30).",
overdueOpenJobsRationale_many: "{{count}} de órdenes de trabajo abiertas tienen una fecha de vencimiento ya pasada (10 puntos cada una, máximo 30).",
overdueOpenJobsRationale_other: "{{count}} órdenes de trabajo abiertas tienen una fecha de vencimiento ya pasada (10 puntos cada una, máximo 30).",
highUrgencyJobsLabel_one: "Orden de trabajo abierta de alta urgencia",
highUrgencyJobsLabel_many: "Órdenes de trabajo abiertas de alta urgencia",
highUrgencyJobsLabel_other: "Órdenes de trabajo abiertas de alta urgencia",
highUrgencyJobsInline_one: "una orden de trabajo abierta de alta urgencia",
highUrgencyJobsInline_many: "órdenes de trabajo abiertas de alta urgencia",
highUrgencyJobsInline_other: "órdenes de trabajo abiertas de alta urgencia",
highUrgencyJobsRationale_one: "{{count}} orden de trabajo abierta tiene urgencia alta (8 puntos cada una, máximo 24).",
highUrgencyJobsRationale_many: "{{count}} de órdenes de trabajo abiertas tienen urgencia alta (8 puntos cada una, máximo 24).",
highUrgencyJobsRationale_other: "{{count}} órdenes de trabajo abiertas tienen urgencia alta (8 puntos cada una, máximo 24).",
pendingApprovalsLabel_one: "Aprobación de informe pendiente",
pendingApprovalsLabel_many: "Aprobaciones de informes pendientes",
pendingApprovalsLabel_other: "Aprobaciones de informes pendientes",
pendingApprovalsInline_one: "una aprobación de informe pendiente",
pendingApprovalsInline_many: "aprobaciones de informes pendientes",
pendingApprovalsInline_other: "aprobaciones de informes pendientes",
pendingApprovalsRationale_one: "{{count}} informe compartido aún no ha sido aprobado por el destinatario (6 puntos cada uno, máximo 18).",
pendingApprovalsRationale_many: "{{count}} de informes compartidos aún no han sido aprobados por el destinatario (6 puntos cada uno, máximo 18).",
pendingApprovalsRationale_other: "{{count}} informes compartidos aún no han sido aprobados por el destinatario (6 puntos cada uno, máximo 18).",
recurringIssuesLabel_one: "Fallo recurrente",
recurringIssuesLabel_many: "Fallos recurrentes",
recurringIssuesLabel_other: "Fallos recurrentes",
recurringIssuesInline_one: "un fallo recurrente",
recurringIssuesInline_many: "fallos recurrentes",
recurringIssuesInline_other: "fallos recurrentes",
recurringIssuesRationale_one: "{{count}} fallo ha aparecido en más de una de las últimas {{window}} inspecciones — la reparación anterior no está aguantando (6 puntos cada uno, máximo 18).",
recurringIssuesRationale_many: "{{count}} de fallos han aparecido en más de una de las últimas {{window}} inspecciones — la reparación anterior no está aguantando (6 puntos cada uno, máximo 18).",
recurringIssuesRationale_other: "{{count}} fallos han aparecido en más de una de las últimas {{window}} inspecciones — la reparación anterior no está aguantando (6 puntos cada uno, máximo 18).",
inspectionFindingsLabel_one: "Hallazgo de inspección sin resolver",
inspectionFindingsLabel_many: "Hallazgos de inspección sin resolver",
inspectionFindingsLabel_other: "Hallazgos de inspección sin resolver",
inspectionFindingsInline_one: "un hallazgo de inspección sin resolver",
inspectionFindingsInline_many: "hallazgos de inspección sin resolver",
inspectionFindingsInline_other: "hallazgos de inspección sin resolver",
inspectionFindingsRationale_one: "La última inspección completada tiene {{count}} elemento fallido o por reparar (4 puntos cada uno, máximo 20).",
inspectionFindingsRationale_many: "La última inspección completada tiene {{count}} de elementos fallidos o por reparar (4 puntos cada uno, máximo 20).",
inspectionFindingsRationale_other: "La última inspección completada tiene {{count}} elementos fallidos o por reparar (4 puntos cada uno, máximo 20).",
noDocumentsLabel: "Sin documentos registrados",
noDocumentsInline: "la falta de documentos registrados",
noDocumentsRationale: "No hay certificados, garantías ni archivos de cumplimiento vinculados a este activo. Los auditores suelen esperar que haya pruebas registradas.",
noCompletedInspectionLabel: "Sin inspección completada de referencia",
noCompletedInspectionInline: "la falta de una inspección completada de referencia",
noCompletedInspectionRationale: "Todavía no hay ninguna inspección completada o aprobada, así que el cumplimiento no se puede verificar con datos de campo.",
staleInspectionLabel: "Última inspección hace más de 90 días",
staleInspectionInline: "una última inspección de hace más de 90 días",
staleInspectionRationale_one: "La inspección completada más reciente fue hace {{count}} día. Cuanto más antiguas son las pruebas, mayor es la incertidumbre en una auditoría.",
staleInspectionRationale_many: "La inspección completada más reciente fue hace {{count}} de días. Cuanto más antiguas son las pruebas, mayor es la incertidumbre en una auditoría.",
staleInspectionRationale_other: "La inspección completada más reciente fue hace {{count}} días. Cuanto más antiguas son las pruebas, mayor es la incertidumbre en una auditoría.",
recentInspectionsLabel: "Actividad de inspección reciente",
recentInspectionsInline: "la actividad de inspección reciente",
recentInspectionsRationale_one: "Se completó {{count}} inspección en los últimos 30 días sin inspecciones programadas ni órdenes de trabajo vencidas — una señal positiva.",
recentInspectionsRationale_many: "Se completaron {{count}} de inspecciones en los últimos 30 días sin inspecciones programadas ni órdenes de trabajo vencidas — una señal positiva.",
recentInspectionsRationale_other: "Se completaron {{count}} inspecciones en los últimos 30 días sin inspecciones programadas ni órdenes de trabajo vencidas — una señal positiva.",
cleanWorkQueueLabel: "Sin trabajo abierto de la última inspección",
cleanWorkQueueInline: "la ausencia de trabajo abierto de la última inspección",
cleanWorkQueueRationale: "No hay órdenes de trabajo abiertas ni hallazgos sin resolver en la última inspección completada.",
},
model: {
placeTypeLabel: "Tipo de lugar",
placeTypeHint: "Un edificio, planta, sala u otra zona. Tus propios tipos de lugar también aparecen aquí.",
customTypeLabel: "Tipo de activo",
customTypeNone: "Ninguno",
vehicleNoParent: "Un vehículo no está dentro de otro activo. En su lugar tiene un sitio base.",
sitsInLabel: "Está en",
sitsInHint: "El lugar, vehículo o elemento en el que está.",
sitsInHintPlace: "El lugar del que forma parte, como la planta de una sala.",
sitsInA11yChange: "Está en {{name}}. Cambiar",
sitsInA11yPick: "Elegir dónde está",
sitsInNone: "No está dentro de nada",
sitsInClear: "Sacar",
sitsInPickerTitle: "¿Dónde está?",
sitsInSearch: "Buscar lugares y activos",
fieldsLabel: "Detalles de {{type}}",
yes: "Sí",
no: "No",
datePlaceholder: "AAAA-MM-DD",
fieldError: {
required: "Rellena este campo",
number: "Introduce un número",
date: "Introduce una fecha como AAAA-MM-DD",
choice: "Elige una de las opciones",
},
fieldsIncompleteTitle: "Faltan algunos detalles",
fieldsIncompleteBody: "Rellena los detalles marcados y vuelve a guardar.",
placementFailedTitle: "No se pudo mover",
placementFailedBody: "El activo se guardó, pero su ubicación no cambió. Inténtalo de nuevo desde el activo.",
placementError: {
vehicle: "Un vehículo no está dentro de otro activo. En su lugar tiene un sitio base.",
placeInPlace: "Un lugar solo puede estar dentro de otro lugar.",
alreadyPlaced: "Este activo ya está en otro sitio. Muévelo en su lugar.",
},
zonesLabel: "Zonas",
zonesHint: "Grupos que cruzan lugares, como un sector de incendio o una zona de limpieza. Sepáralas con comas. Las reglas de grupo y las rondas pueden elegir por zona.",
zonesPlaceholder: "Sector de incendio 2, Ala norte",
placeTypes: {
property: "Propiedad",
building: "Edificio",
wing: "Ala",
floor: "Planta",
room: "Sala",
unit: "Unidad",
ward: "Pabellón",
data_hall: "Sala de datos",
rack: "Rack",
plant_room: "Sala de máquinas",
car_park: "Aparcamiento",
yard: "Patio",
grounds: "Terrenos",
pool: "Piscina",
gate: "Puerta",
area: "Zona",
},
card: {
title: "Dónde está",
homeTitle: "Sitio base",
noHomeSite: "Aún sin sitio base",
notInside: "No está dentro de otro lugar",
twoParents: "Esto está en dos lugares: {{names}}. Conserva uno.",
keepParent: "Conservar {{name}}",
contains_one: "Contiene {{count}} elemento",
contains_many: "Contiene {{count}} elementos",
contains_other: "Contiene {{count}} elementos",
directlyInside_one: "Directamente dentro ({{count}})",
directlyInside_many: "Directamente dentro ({{count}})",
directlyInside_other: "Directamente dentro ({{count}})",
andMore_one: "y {{count}} más",
andMore_many: "y {{count}} más",
andMore_other: "y {{count}} más",
addPlace: "Añadir lugar dentro",
addEquipment: "Añadir equipo aquí",
move: "Mover",
putInside: "Poner dentro",
takeOut: "Sacar",
placeReport: "Informe de este lugar",
zones: "Zonas",
rollupPlaces_one: "{{count}} lugar",
rollupPlaces_many: "{{count}} lugares",
rollupPlaces_other: "{{count}} lugares",
rollupEquipment_one: "{{count}} equipo",
rollupEquipment_many: "{{count}} equipos",
rollupEquipment_other: "{{count}} equipos",
rollupVehicles_one: "{{count}} vehículo",
rollupVehicles_many: "{{count}} vehículos",
rollupVehicles_other: "{{count}} vehículos",
rollupOther_one: "{{count}} otro",
rollupOther_many: "{{count}} otros",
rollupOther_other: "{{count}} otros",
rollupAtRisk_one: "{{count}} con riesgo alto",
rollupAtRisk_many: "{{count}} con riesgo alto",
rollupAtRisk_other: "{{count}} con riesgo alto",
rollupDueVisits_one: "{{count}} visita pendiente",
rollupDueVisits_many: "{{count}} visitas pendientes",
rollupDueVisits_other: "{{count}} visitas pendientes",
rollupOpenJobs_one: "{{count}} trabajo abierto",
rollupOpenJobs_many: "{{count}} trabajos abiertos",
rollupOpenJobs_other: "{{count}} trabajos abiertos",
rollupSeeWork: "Ver todo el trabajo de dentro",
addMany: "Añadir muchos dentro",
startRound: "Empezar una ronda",
groupRule: "Añadir una regla de grupo",
},
},
bulk: {
buildingTitle: "Configurar un edificio",
seriesTitle: "Añadir muchos a la vez",
buildingAction: "Configurar un edificio",
buildingActionA11y: "Configurar un edificio en {{site}}",
buildingIntro: "Elige el tipo de edificio y su tamaño. Verás cada lugar, y lo que suma a tu factura, antes de crear nada.",
seriesIntro: "Añade una serie numerada de lugares o elementos dentro de {{place}}.",
presetLabel: "Tipo de edificio",
multiUseHint: "¿un sitio de uso mixto? Configura cada edificio por separado, cada uno con su tipo.",
siteLabel: "Sitio",
siteSearch: "Buscar sitios",
noSite: "Elige un sitio",
buildingNameLabel: "Nombre del edificio",
buildingNamePlaceholder: "Edificio A",
buildingNameRequired: "Ponle un nombre al edificio",
defaultBuildingName: "Edificio principal",
floorsLabel: "Plantas",
firstFloorLabel: "Las plantas empiezan en",
spaceLabel: "En cada planta",
perFloorLabel: "Cantidad de {{type}} por planta",
perSpaceLabel: "Cantidad de {{inside}} en cada {{type}}",
extrasLabel: "Añadir también",
sitePlacesLabel: "Lugares compartidos del sitio",
sitePlacesHint: "Estos van a nivel de sitio, no dentro del edificio. Solo se muestran los que el sitio aún no tiene.",
addTypesLabel: "Añadir los tipos de activo habituales",
addTypesHint: "Añade {{types}} con sus datos, si aún no los tienes.",
seriesKindLabel: "Qué añadir",
patternLabel: "Patrón de nombre",
patternHint: "Usa # para el número. ## rellena a dos cifras, así Sala ## da Sala 01, Sala 02.",
defaultItemPattern: "Elemento ##",
startLabel: "Empezar en",
countLabel: "Cuántos",
previewTitle: "Lo que se creará",
quoteTitle_one: "{{count}} activo nuevo",
quoteTitle_many: "{{count}} activos nuevos",
quoteTitle_other: "{{count}} activos nuevos",
quoteBilled: "Cada lugar y cada elemento es un activo facturado.",
quoteNow_one: "Ahora tiene {{count}} activo.",
quoteNow_other: "Ahora tiene {{count}} activos.",
quoteNow_many: "Ahora tiene {{count}} activos.",
quoteAfter: "Tendrás {{after}} activos.",
quoteAfterLimit: "Tendrás {{after}} de los {{limit}} activos que permite tu plan.",
quotePrice: "Tu coste mensual pasa de {{before}} a {{after}}.",
quoteOverLimit: "Es más de lo que permite tu plan ({{limit}} activos). Cambia de plan primero o crea menos.",
quoteNeedsPlan: "Elige un plan antes de añadir más activos.",
tooMany: "Como máximo {{max}} a la vez. Crea menos o hazlo por partes.",
createButton_one: "Crear {{count}} activo",
createButton_many: "Crear {{count}} activos",
createButton_other: "Crear {{count}} activos",
created_one: "{{count}} activo creado",
created_many: "{{count}} activos creados",
created_other: "{{count}} activos creados",
failedTitle: "No se pudieron crear",
failedBody: "No se creó nada. Comprueba tu conexión e inténtalo de nuevo.",
names: {
groundFloor: "Planta baja",
floor: "Planta {{n}}",
space: {
room: "Sala {{code}}",
ward: "Unidad {{code}}",
data_hall: "Sala de datos {{n}}",
gate: "Puerta {{code}}",
unit: "Local {{code}}",
area: "Zona {{code}}",
},
inside: {
room: "Habitación {{parent}}-{{n}}",
rack: "Bastidor {{parent}}-{{n}}",
},
},
},
presets: {
names: {
office_block: "Edificio de oficinas",
hotel: "Hotel",
hospital: "Hospital",
data_centre: "Centro de datos",
airport: "Aeropuerto",
shopping_centre: "Centro comercial",
school: "Colegio",
warehouse: "Almacén",
custom: "Otra cosa",
},
descriptions: {
office_block: "Plantas de oficinas, con recepción y sala de máquinas.",
hotel: "Habitaciones en cada planta, recepción, restaurante, gimnasio, piscinas y sala de máquinas.",
hospital: "Unidades en cada planta con habitaciones dentro, recepción y sala de máquinas.",
data_centre: "Salas de datos con racks, salas de máquinas, un patio y una puerta.",
airport: "Puertas en cada planta, facturación, sala de equipajes y aparcamiento.",
shopping_centre: "Locales en cada planta, zona de restauración y aparcamiento.",
school: "Aulas en cada planta, un salón de actos, terrenos y aparcamiento.",
warehouse: "Zonas de almacenaje, una oficina, un patio y una puerta.",
custom: "Solo plantas y salas. Añade tus propios tipos de lugar más tarde.",
},
extras: {
reception: "Recepción",
restaurant: "Restaurante",
gym: "Gimnasio",
pool: "Piscina",
plant_room: "Sala de máquinas",
check_in: "Facturación",
baggage_hall: "Sala de equipajes",
food_court: "Zona de restauración",
hall: "Salón de actos",
office: "Oficina",
car_park: "Aparcamiento",
grounds: "Terrenos",
yard: "Patio",
gate: "Puerta",
},
types: {
guest_room: "Habitación de huéspedes",
fire_door: "Puerta cortafuegos",
lift: "Ascensor",
escalator: "Escalera mecánica",
air_handler: "Unidad de tratamiento de aire",
chiller: "Enfriadora",
boiler: "Caldera",
generator: "Grupo electrógeno",
ups: "SAI",
crac_unit: "Unidad CRAC",
pdu: "PDU",
infusion_pump: "Bomba de infusión",
medical_gas_outlet: "Toma de gases medicinales",
baggage_belt: "Cinta de equipajes",
jet_bridge: "Pasarela de embarque",
dock_door: "Puerta de muelle",
racking: "Estanterías",
},
fields: {
beds: "Camas",
accessible: "Accesible",
fireRating: "Resistencia al fuego",
selfClosing: "Cierre automático",
capacityKg: "Capacidad (kg)",
floorsServed: "Plantas que sirve",
riseM: "Desnivel (m)",
airflow: "Caudal de aire (m³/s)",
filterSize: "Tamaño del filtro",
refrigerant: "Refrigerante",
capacityKw: "Potencia (kW)",
fuel: "Combustible",
outputKw: "Potencia de salida (kW)",
ratingKva: "Potencia nominal (kVA)",
batteryDate: "Batería instalada el",
ratingA: "Corriente nominal (A)",
phase: "Fase",
serialNumber: "Número de serie",
nextCalibration: "Próxima calibración",
gas: "Gas",
lengthM: "Longitud (m)",
leveller: "Rampa niveladora",
bays: "Módulos",
loadRatingKg: "Carga admisible (kg)",
},
},
  valueLife: {
    title: "Valor y vida útil (opcional)",
    hint: "Asset 360 lo usa para mostrar su vida útil, su valor y lo que cuestan las reparaciones frente a sustituirlo.",
    installedOn: "Instalado el",
    installedOnPlaceholder: "AAAA-MM-DD",
    expectedLife: "Vida útil prevista en años",
    expectedLifePlaceholder: "Por ejemplo 15",
    purchaseCost: "Coste de compra",
    replacementCost: "Coste de sustitución",
    replacementCostHelper: "Lo que costaría sustituirlo hoy.",
    currency: "Moneda",
    currencyPlaceholder: "Por ejemplo EUR",
    invalidTitle: "Revise valor y vida útil",
    invalidBody: "Algunos datos de valor y vida útil no son válidos. Corrija o vacíe los campos marcados.",
    saveFailedTitle: "Valor y vida útil no guardados",
    saveFailedBody: "El resto del activo se guardó. Vuelva a guardar valor y vida útil.",
    error: {
      installedOn: "Use una fecha como 2019-06-30.",
      expectedLifeYears: "Introduzca años enteros de 1 a 200.",
      purchaseCost: "Introduzca un importe, como 1250 o 1250.50.",
      replacementCost: "Introduzca un importe, como 1250 o 1250.50.",
      currency: "Use un código de tres letras, como EUR.",
    },
  },
  report360Charts: {
    other: "Otros",
    dataQualityA11y: "Calidad de los datos {{score}} de 100, {{band}}",
    measureA11y: "{{label}}: {{score}} de 100",
    notAvailable: "no disponible",
    trendEmptyA11y: "{{label}}: aún no hay cifras guardadas.",
    trendEmpty: "Aún no hay cifras diarias guardadas. Se acumulan noche tras noche.",
  },
  report360,
};
